<template>
  <div v-if="getPermission.stc.view || getPermission.stcExtraCost.view">  


   <yard-export-form ref="CreateIngate" mode="Booking"/>
  <yard-export-form ref="Instruction" mode="Instruction"/>

  <dispatch-form ref="DispatchForm" mode="YY" action = "CREATE"/>
  <dispatch-form ref="DispatchFormCopy" mode="YY" action = "COPY"/>
  <dispatch-form ref="DispatchFormChange" mode="YY" action = "CHANGE"/>
  <outbound-booking ref="OutboundBooking" mode="YY" :action="onfresh"/>

  <md-dialog :md-active.sync="isPictureModalShowing">
    <md-dialog-content>
      <span class="heading2">{{photoTitle}}</span>
      <calling-api path="/api/w/ccr/photo/getCCRPhoto">
      <div v-if="photos.length === 0">
        <h3>You don't have any photos from CCR Log</h3>
      </div>
      <div v-else>
        <view-image  :key="p.imgUrl" :src="p.imgUrl" v-for="p in photos">
         <div v-if="!isLoading" class="space">
            <h3>Type: {{p.title}}</h3>
            <p>File Name: {{getPhotoName(p)}}</p>
          </div>
          <div v-if="isLoading" class="space">
            <p>File Name: {{getPhotoName(p)}}</p>
            <p>{{p.refTimeStamp}}</p>
          </div>            
        </view-image>
      </div>
        
      </calling-api>
    </md-dialog-content>
    <md-dialog-actions>
      <download-pictures-button :zip-file-name="photoZipFileName"
                                :file-prefix-for-each-file="filePrefixForEachFile"
                                :pics="photos.map(it=>it.photoUrl)"
                                v-if="isLoading"/>
      <md-button class="md-primary" @click="isPictureModalShowing = false; isLoading = false;">Close</md-button>      </md-dialog-actions>
  </md-dialog>
  <md-dialog :md-active.sync="isPictureModalShowing3">
      <md-dialog-content>
        <h3>Driver Confirmation Signature</h3>
        <!--
        <calling-api path="/api/w/ccic/photo/get">
          <view-image :key="p.photoUrl" :src="p.photoUrl" v-for="p in photos">
            <p>Photo Type: {{getPhotoName(p,"INOUT")}}</p>
            <p>Stage info: {{p.photoKey.slice(0, -3)}}</p>
          </view-image>
        </calling-api>
      -->
          <view-image :key="signURL" :src="signURL">
          </view-image>

      </md-dialog-content>

      
      <md-dialog-actions>
        <!-- <download-pictures-button :zip-file-name="photoZipFileName"
                                  :file-prefix-for-each-file="filePrefixForEachFile"
                                  :pics="photos.map(it=>it.photoUrl)"/> -->
        <md-button class="md-primary" @click="isPictureModalShowing3 = false">Close</md-button>
      </md-dialog-actions>
  </md-dialog>

    <md-dialog :md-active.sync="isChassisPictureModalShowing">
      <md-dialog-content>
        <h3>Bobtail Chassis Photo</h3>
        <!--
        <calling-api path="/api/w/ccic/photo/get">
          <view-image :key="p.photoUrl" :src="p.photoUrl" v-for="p in photos">
            <p>Photo Type: {{getPhotoName(p,"INOUT")}}</p>
            <p>Stage info: {{p.photoKey.slice(0, -3)}}</p>
          </view-image>
        </calling-api>
      -->
      <calling-api path="/api/w/ccic/photo/chassisPlus">
      <div v-if="photos.length === 0">
        <h3>You don't have any photos from Chassis Plus</h3>
      </div>
      <div v-else>
        <view-image  :key="p.photoUrl" :src="p.photoUrl" v-for="p in photos">
         <div v-if="!isLoading" class="space">
            <h3>Type: {{p.photoKey}}</h3>
            <p>File Name: {{getChassisPhotoName(p)}}</p>
          </div>
          <div v-if="isLoading" class="space">
            <p>File Name: {{getChassisPhotoName(p)}}</p>
            <p>{{p.refTimeStamp}}</p>
          </div>            
        </view-image>
      </div>

      </calling-api>

      </md-dialog-content>

      
      <md-dialog-actions>
        <download-pictures-button :zip-file-name="photoZipFileName"
                                  :file-prefix-for-each-file="filePrefixForEachFile"
                                  :pics="photos.map(it=>it.photoUrl)"/>
        <md-button class="md-primary" @click="isChassisPictureModalShowing = false">Close</md-button>
      </md-dialog-actions>
  </md-dialog>



  <md-card class="searchPanel">
    <md-card-content>
      <div class="md-layout md-gutter">
        <!-- search criteria start -->
        <div  v-if="active" class="md-layout-item md-size-20 md-small-size-100">
          <div class = "inputBox">
                 <auto-complete-master-data-multiple-select
                     label="Status"
                     :prepared-options="this.getMasterDataAsSelectOptionByGroup('GST_LOAD_STATUS')"
                     v-model="searchRequest.loadStatus"
                 />
          </div>
          <div class = "inputBox" >
             <auto-complete-master-data-select
                                              group="GST_STAGE_STATUS"
                                              label="Stage Status"
                                              :init-value="searchRequest.stageStatus"
                                              :on-item-changed="handleStageStatusChanged"
                                              >
             </auto-complete-master-data-select>
          </div>
          <div class = "inputBox" > 
            <auto-complete-master-data-select
                        group="STC_STAGE_TYPE"
                        label="Stage Type"
                        :init-value-id="searchRequest.stageType"
                        :on-item-changed="handleStageTypeChanged">
            </auto-complete-master-data-select>
          </div>
          <div class = "inputBox" >
             <auto-complete-master-data-select
                                              group="REC_WINDOW"
                                              label="Rev. Windows"
                                              :init-value="searchRequest.receivingWindow"
                                              :on-item-changed="handleWindowsChanged"
                                              >
             </auto-complete-master-data-select>
          </div>


        </div>
        <div  v-if="active" class="md-layout-item md-size-20 md-small-size-100">
          <div class = "inputBox" >
              <datepicker v-model="searchRequest.moveInDate.startDate" >
                 <label>Move In Date</label>
              </datepicker>
          </div>
          <div class = "inputBox" >
              <datepicker v-model="searchRequest.inGateDate.startDate" >
                 <label>In Gate Date</label>
              </datepicker>
          </div>
          <div class = "inputBox">
              <md-field>
                  <label>Chassis #</label>
                  <md-input v-model="searchRequest.chassisNo"/>
              </md-field>
          </div>
          <div class = "inputBox">
              <md-field>
                  <label>Booking #</label>
                  <md-input v-model="searchRequest.bookingNo" />
              </md-field>
          </div>
          <div class = "inputBox">
              <md-field>
                  <label>STC DO</label>
                  <md-input v-model="searchRequest.deliveryOrder"/>
              </md-field>
          </div>
          <div class = "inputBox">
              <auto-complete-master-data-select
                      group="STC_COSTREL_STATUS"
                      label="Cost Relevant"
                      :init-value="searchRequest.costRelevant"
                      :on-item-changed="handleCostRelChanged"
                >
              </auto-complete-master-data-select>
          </div>

        </div>
        <div  v-if="active" class="md-layout-item md-size-20 md-small-size-100">
          <div class = "inputBox" >
              <datepicker v-model="searchRequest.moveInDate.endDate">
                  <label>Move In Date To</label>
              </datepicker>
          </div>
          <div class = "inputBox" >
              <datepicker v-model="searchRequest.inGateDate.endDate">
                  <label>In Gate Date To</label>
              </datepicker>
          </div>
          <div class = "inputBox">
              <md-field>
                  <label>Load Key</label>
                  <md-input v-model="searchRequest.loadKey" />
              </md-field>
          </div>
          <div class = "inputBox">
              <auto-complete-master-data-select
                       label="Carrier Name"
                       display-type="idOnly"
                       :prepared-options="this.getMasterDataAsSelectOptionByGroup('STC_CARRIER')"
                       :init-value-id="searchRequest.carrier"
                       :on-item-changed="handleCarrierChanged">
              </auto-complete-master-data-select>
          </div>
          <div class = "inputBox">
              <md-field>
                  <label>Customer Order</label>
                  <md-input v-model="searchRequest.customerOrder"/>
              </md-field> 
          </div>
          <div class = "inputBox">
            <auto-complete-master-data-select
                                                group="GST_RATE_COST"
                                                label="Freight Type"
                                                :init-value="searchRequest.freightType"
                                                :on-item-changed="handleFreightTypeChanged"
                                                >
            </auto-complete-master-data-select>
          </div>

        </div>
        <div  v-if="active" class="md-layout-item md-size-20 md-small-size-100">
          <div class = "inputBox" >
              <datepicker v-model="searchRequest.cargoCutOff.startDate">
                  <label>Cargo Cut Date</label>
              </datepicker>
          </div>
          <div class = "inputBox" >
              <datepicker v-model="searchRequest.apptDate.startDate">
                  <label>Appt Date</label>
              </datepicker>
          </div>
          <div class = "inputBox">
              <md-field>
                 <label>Appointment</label>
                 <md-input v-model="searchRequest.appointment"/>
              </md-field>
          </div>
          <div class = "inputBox">
              <md-field>
                  <label>Container#</label>
                  <md-input v-model="searchRequest.containerNo"/>
              </md-field>
          </div>
          <div class = "inputBox">
              <md-field>
                  <label>Pick up Location</label>
                  <md-input v-model="searchRequest.pickupLocation"/>
              </md-field>
          </div>
          <div class = "inputBox" >
              <auto-complete-stc-driver-group-select
                      label="Driver Group"
                      :options="stcDriverGroupOption"
                      v-model="searchRequest.driverGroup"
                   >
              </auto-complete-stc-driver-group-select>
          </div>

        </div>
        <div  v-if="active" class="md-layout-item md-size-20 md-small-size-100">
          <div class = "inputBox" >
              <datepicker v-model="searchRequest.cargoCutOff.endDate">
                  <label>Cargo Cut Date To</label>
              </datepicker>
          </div>
          <div class = "inputBox" >
              <datepicker v-model="searchRequest.apptDate.endDate">
                  <label>Appt Date To</label>
              </datepicker>
          </div>
          <div class = "inputBox">
            <auto-complete-master-data-select
                    group="PUSH_STATUS"
                    label="Push Status"
                    :init-value="searchRequest.pushStatus"
                    :on-item-changed="handlePushStatusChanged"
             >
             </auto-complete-master-data-select>
          </div>
          <div class = "inputBox" >
              <auto-complete-master-data-select
                        group="CCR_CNTRTYPE"
                        label="Container Type"
                        :init-value="searchRequest.ctnrType"
                        :on-item-changed="handleCtnrTypeChanged"
                    >
              </auto-complete-master-data-select>
          </div>
          <div class = "inputBox">
              <md-field>
                  <label>Destination</label>
                  <md-input v-model="searchRequest.destination" />
              </md-field>
          </div>
          <div class = "inputBox">
              <auto-complete-select
                     :options="drivers"
                     label="Driver"
                     :value="searchRequest.driverId"
                     :on-item-changed="handleDriverRequestChanged"
                    >
              </auto-complete-select>
          </div>

        </div>
        <!-- Search criteria End -->
        <div v-if="getPermission.ccic.edit || getPermission.stc.view" class="md-layout-item md-size-100 md-small-size-100">
         <!--
          <callingApiCenter :paths="['/api/w/gst/yardexportlist', '/api/w/users','/api/w/gst/updateyardstage','/api/w/excel/generate', '/api/w/gst/createyardstage','/api/w/gst/createyardstage/WebCopyDeleteStage','/api/w/gst/WebYardGroupOutGate','/api/w/ccic/photo/get','/api/w/DOs/WebAssignDoHeaderWithStage', '/api/w/DOs/getdoheader']">
         -->   
          <callingApiCenter :paths="['/api/w/gst/yardexportlist', '/api/w/gst/WebSearchDispatchList', '/api/w/stc/dispatchstagelist']">
            <callingApiCenter path=" /api/w/gst/loadlist/create" :not-display-error="true">
             <!--<md-button class="md-raised" :disabled="!canNew" @click="doNew">New</md-button>-->
             <!--<md-button class="md-raised custButton " :disabled="!canEditSingle" @click="CreateIngate" ><span class="icons-center material-icons">create</span> IN GATE</md-button>-->
             <!--<md-button class="md-raised custButton"  :disabled="!canOutGate" @click="doOutGate" ><span class="icons-center material-icons">update</span>Out Gate</md-button>-->
             <!--<md-button class="md-raised custButton " :disabled="!canEditSingle" @click="doChange" ><span class="icons-center material-icons">create</span> Change</md-button>-->
             <!--<md-button class="md-raised custButton " :disabled="!canEditSingle" @click="doCopy" ><span class="icons-center material-icons">file_copy</span> Copy</md-button>-->
             <!--<md-button class="md-raised custButton" :disabled="!canSave" @click="doSave"><span class="icons-center material-icons">update</span>Save</md-button>-->
             <!--<md-button class="md-raised custButton"  :disabled="!noGates" @click="doEdit"><span class="icons-center material-icons">file_copy</span>Edit</md-button>-->
             <!-- <md-button class="md-raised custButton"  :disabled="!canEdit" @click="doCopy"><span class="icons-center material-icons">file_copy</span>Stage</md-button> -->
             <!-- <md-button class="md-raised custButton" :disabled="!canDeleteBooking" @click="doDeleteBooking"><span class="icons-center material-icons">delete</span>Booking</md-button>-->
             <!--<md-button class="md-raised custButton" :disabled="!canDelete" @click="doDeleteStage"><span class="icons-center material-icons">delete</span>Stage</md-button>-->
             <!--<md-button class="md-raised custButton"  :disabled="!canDeleteLoad" @click="doDeleteLoad"><span class="icons-center material-icons">delete</span>Load</md-button>-->
             <b-notification class = "notifySize"
                type="is-success"
                v-model="notifyActive"
                aria-close-label="Close notification">
                {{notifyMessage}}
             </b-notification>

             <!--<md-button class="md-raised custButton" :disabled="!canEdit" @click="doCockPit" ><span class="icons-center material-icons"  >create</span>Assign BK</md-button>-->
<!--
             <md-button
                class="custButton md-raised"
                @click="getBookingAssign()"
                :disabled="!getAssignBookingCond"
                > 
                Assign BK
              </md-button>
  -->              
             <!--
              <md-button 
                class="custButton md-raised"
                @click="getBookingUnAssign()"
                :disabled="!getUnAssignBookingCond || this.getPermission.fsireadonly.view || this.getPermission.ccicqc.view || this.getPermission.fsireadonlyforerl.view"
                > 
                Un-Assign
              </md-button>
            -->
  <!--          
            <md-button 
                class="custButton md-raised"
                @click="getBookingUnAssign()"
                :disabled="!getUnAssignBookingCond"
                > 
                Un-Assign
              </md-button>
  -->            
             <!--<md-button class="md-raised custButton" :disabled="!canEdit" @click="doCockPit" ><span class="icons-center material-icons"  >create</span>Un-Assign BK</md-button>-->
             <!--<md-button class="md-raised custMedButton" @click="editAppt" ><span class="icons-center material-icons"  >create</span>Appointment</md-button>-->
             <!--<md-button class="md-raised custMedButton" @click="editDriverGroup" ><span class="icons-center material-icons"  >create</span>Driver Group</md-button>-->

             <!--<md-button class="md-raised custButton" :disabled="canSave || !this.getPermission.stcClerk.view" @click="doSave" ><span class="icons-center material-icons"  >save</span>Save</md-button>-->

             <md-button class="md-raised custMedButton" :disabled="!canEdit || !this.getPermission.stcClerk.view" @click="doCockPit" ><span class="icons-center material-icons"  >grid_view</span>CockPit</md-button>
             <!--<md-button class="md-raised custButton" :disabled="!canEdit" @click="doCockPit" ><span class="icons-center material-icons"  >create</span>DS</md-button>-->
             <!--<md-button class="md-raised custMedButton" @click="doAsgDriver" ><span class="icons-center material-icons"  >person_add</span>Assign Driver</md-button>-->
             <md-button class="md-raised custMedButton" @click="doLoad" ><span class="icons-center material-icons"  >local_shipping</span>Load</md-button>
             <md-button id = "searchTag" @click="doSearch"  class=" custButton btn-search-special-form-container md-primary md-raised">Search</md-button>
             <md-button   @click="doClear" class="md-raised custButton">Clear</md-button>
             <md-button
                 class="custButton md-raised"
                 @click="doDownloadExcel"
                 :disabled="!getDownloadCond"
             > 
             Download
             </md-button>
           <input class = "custSearchBar" type="text"
                  placeholder="Searching Term"
                  v-model="filter"

                  />
            <md-checkbox v-model="bobtailOnly">BobTail Only</md-checkbox>
            <md-checkbox v-model="chassisPlus">Addition Chassis Pic</md-checkbox>      
            <!--      
           <div style="margin-top: -36px; margin-left: 850px; width: 150px;">
              <md-checkbox v-model="bobtailOnly">BobTail Only</md-checkbox>
           </div>
          -->       
          <md-button class="md-icon-button custButtonRight" @click="mouseLeave" id="expand-button">
            <md-icon v-if="active == false">keyboard_arrow_down</md-icon>
            <md-icon v-if="active == true">keyboard_arrow_up</md-icon>
          </md-button>
            </callingApiCenter>
          </callingApiCenter>
        </div>        
      </div>
    </md-card-content>
  </md-card>

  
  <pagination :items="filteredRows">
    <template slot-scope="{pageItems}">
      <md-card class="data-table-container">
        <div class="outer-container ">
          <div class="inner-container table-wrapper ">
            <div class="table-header">
              <table id="headertable" v-if="bobtailOnly == false">
                <thead>
                <tr>
                  <th class="header-cell w2">
                    <md-checkbox v-model="selectAll" @change="changeSelChkBox"></md-checkbox>
                    <md-tooltip md-direction="top">Select All/DeSelect All</md-tooltip>
                  </th>
                    <th class="header-cell center w5" v-on:click="sortFunction('salesOffice')">Sales Office</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('receivingWindows')">Receiving Window</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('loadStatus')">Load Status</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('stageStatus')">Stage Status</th>
                    <!--<th class="header-cell center w5" v-on:click="sortFunction('seqNo')">Load Key</th>-->
                    <th class="header-cell center w10" v-on:click="sortFunction('driver')">Driver</th>
                    <th class="header-cell center w8" v-on:click="sortFunction('containerNo')">Container</th>
                    <th class="header-cell center w8" v-on:click="sortFunction('chassisNo')">Chassis</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('carrier')">Carrier</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('stage')">Stage#</th>   
                    <th class="header-cell center w5" v-on:click="sortFunction('stageType')">Stage Type</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('freightType')">Freight Type</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('costRelevant')">Cost Relevant</th> 
                    <th class="header-cell center w10" v-on:click="sortFunction('dispatcherInstruction')">Stage Dispatcher Instruction</th>
                    <th class="header-cell center w8" v-on:click="sortFunction('bookingNo')">Booking</th>
                    <th class="header-cell center w8" v-on:click="sortFunction('bookingNo')">Empty Pulled BK</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('bookingNo')">Mis-match BK</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('cutLDF')">Cargo Cut-off</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('dropOffTml')">Drop Off Tml</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('appointment')">Apointment</th>
                    <th class="header-cell center w10" v-on:click="sortFunction('apptDate')">Appt Date</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('apptTime')">Appt Time</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('driverGroup')">Driver Group</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('driverId')">Driver</th>
                    <th class="header-cell center w10">Container Image</th>
                    <th class="header-cell center w10">Chassis Image</th>
                    <th class="header-cell center w10">Chassis BOL</th>
                    <th class="header-cell center w10" v-on:click="sortFunction('pushStatus')">Push Status</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('ctnrType')">CTN Type</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('source')">Source</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('chzUsedDate')">Used Day</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('chzUsedDate')">Manual Used Day</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('chzEndDate')">In Gate Date</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('loadKey')">Load Key</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('yardLoc')">Yard Loc.</th>
                    <th class="header-cell center w8" v-on:click="sortFunction('customerOrder')">Customer order(IBD)</th>
                    <th class="header-cell center w7" v-on:click="sortFunction('sealNumber')">Seal#</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('scaleTicket')">Weight Ticket</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('pickupLoc')">PickUp Loc.</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('pickupTml')">PickUp Tml</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('deliveryTo')">Delivery To</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('truckId')">Truck ID</th>
                    <th class="header-cell center w10" v-on:click="sortFunction('dispatchInstuction')">Dispatch Instruction</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('deliveryOrder')">STC DO</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('stcLoadConfirmedBy')">Load Confirmed By</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('stcLoadConfirmedAt')">Load Confirmed Date</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('stcLoadConfirmedAt')">Load Confirmed Time</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('stcStageConfirmedBy')">Stage Confirmed By</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('stcStageConfirmedAt')">Stage Confirmed Date</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('stcStageConfirmedAt')">Stage Confirmed Time</th>
                     <!--
                    <th class="header-cell center w5" v-on:click="sortFunction('stcDriverTasksConfirmed')">Task Conf</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('stcDriverTasksConfirmedAt')">Task Conf At</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('stcDriverTaskConfirmedBy')">Task Conf By</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('driverTaskConfirmSignImage')">Task Sign</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('driverTaskConfirmKey')">Task Key</th>
                -->
                    <th class="header-cell center w5" v-on:click="sortFunction('rateChanged')">Rate Changed</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('stcDriverTaskPayConfirmed')">Rate Conf</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('stcDriverTasksPayConfirmedAt')">Rate Conf On</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('stcDriverTasksPayConfirmedAt')">Rate Conf At</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('stcDriverTaskPayConfirmedBy')">Rate Conf By</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('driverPayConfirmSignImage')">Rate Sign</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('driverPayConfirmKey')">Rate Key</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('seqNo')">Load Key</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('route')">Route#</th>
                     
                  <!--
                  <th class="header-cell center w5" v-on:click="sortFunction('salesOffice')">Sales Office</th>
                  <th class="header-cell center w5" v-on:click="sortFunction('receivingWindows')">Receiving Window</th>
                  <th class="header-cell center w5" v-on:click="sortFunction('loadStatus')">Load Status</th>
                  <th class="header-cell center w5" v-on:click="sortFunction('stageStatus')">Stage Status</th>-->
                  <!--<th class="header-cell center w5" v-on:click="sortFunction('seqNo')">Load Key</th>-->
                  <!--
                  <th class="header-cell center w8" v-on:click="sortFunction('containerNo')">Container</th>
                  <th class="header-cell center w8" v-on:click="sortFunction('chassisNo')">Chassis</th>
                  <th class="header-cell center w5" v-on:click="sortFunction('carrier')">Carrier</th>
                  <th class="header-cell center w5" v-on:click="sortFunction('carrier')">Grade</th>
                  <th class="header-cell center w5" v-on:click="sortFunction('bookingNo')">Booking #</th>
                  <th class="header-cell center w5" v-on:click="sortFunction('cutLFD')">Cargo Cut-off Date</th>
                  <th class="header-cell center w5" v-on:click="sortFunction('appointment')">Appointment</th>
                  <th class="header-cell center w8" v-on:click="sortFunction('apptDate')">Appt Date</th>
                  <th class="header-cell center w5" >Appt Time</th>
                  <th class="header-cell center w5" >Driver Group</th>
                  <th class="header-cell center w10" v-on:click="sortFunction('driverId')">Driver</th>
                  <th class="header-cell center w5" v-on:click="sortFunction('truckId')">Truck ID</th>
                  <th class="header-cell center w10" v-on:click="sortFunction('driverId')">Container Image</th>
                  <th class="header-cell center w10" v-on:click="sortFunction('driverRemark')">Driver Remark</th>
                  <th class="header-cell center w10" v-on:click="sortFunction('pushStatus')">Push Status</th>
                  <th class="header-cell center w5" v-on:click="sortFunction('ctnrType')">CTN Type</th>
                  <th class="header-cell center w5" v-on:click="sortFunction('ctnrType')">Source</th>
                  <th class="header-cell center w5" v-on:click="sortFunction('ctnrType')">Used Day</th>
                  <th class="header-cell center w5" v-on:click="sortFunction('ctnrType')">CHZ End Date</th>
                  <th class="header-cell center w5" v-on:click="sortFunction('ctnrType')">Load Key</th>
                  <th class="header-cell center w5" v-on:click="sortFunction('ctnrType')">Seq No</th>
                  <th class="header-cell center w10" v-on:click="sortFunction('locationNumber')">Yard Loc.</th>
                  <th class="header-cell center w5" v-on:click="sortFunction('deliveryOrder')">Cust Order(IBD)</th>
                  <th class="header-cell center w5" v-on:click="sortFunction('deliveryOrder')">Seal #</th>
                  <th class="header-cell center w5" v-on:click="sortFunction('deliveryOrder')">Weight Ticket</th>
                  <th class="header-cell center w5" v-on:click="sortFunction('deliveryOrder')">Pickup Loc</th>
                  <th class="header-cell center w10" v-on:click="sortFunction('deliveryOrder')">Delivery To</th>
                  <th class="header-cell center w7" v-on:click="sortFunction('deliveryOrder')">Pickup Tml</th>
                  <th class="header-cell center w5" v-on:click="sortFunction('deliveryOrder')">STC DO</th>-->
                  <!--<th class="header-cell center w5" >GST DO Item</th>-->
                  <!--<th class="header-cell center w5" >Route #</th>
                  <th class="header-cell center w10" >Route Desc</th>-->

<!--
                  <th class="header-cell center w5" v-on:click="sortFunction('stage')">Stage #</th>
                  <th class="header-cell center w5" v-on:click="sortFunction('stageType')">IN/OUT</th>
                  <th class="header-cell center w15" v-on:click="sortFunction('pickupLocationCode')">Pickup Location Code</th>
                  <th class="header-cell center w10" >Pickup Location Name</th>
                  <th class="header-cell center w15" v-on:click="sortFunction('deliverLocationCode')">Destionation Code</th>
                  <th class="header-cell center w10" >Destionation Name</th>
                  <th class="header-cell center w10" >Instruction</th>
                  <th class="header-cell center w5" >Cost Relevant</th>
                  <th class="header-cell center w5" >Street Turn</th>
                  <th class="header-cell center w5" >Freight Type</th>
                  <th class="header-cell center w5" v-on:click="sortFunction('chzStartDate')">CHZ start date</th>
                  <th class="header-cell center w5" v-on:click="sortFunction('pickupDate')">Pickup Date</th>
                  <th class="header-cell center w5" >Reference #</th>
                  <th class="header-cell center w8" >Create Person</th>
                  <th class="header-cell center w8" >Create Date</th>
                  <th class="header-cell center w8" >Update Person</th>
                  <th class="header-cell center w8" >Update Date</th>
                  <th class="header-cell center w8" >Grade</th>
                  <th class="header-cell center w8" >Weight</th>
                  <th class="header-cell center w8" >SAP Status</th>
-->                    
                </tr>
                </thead>
              </table>
              <table id="headertable" v-if="bobtailOnly == true">
                <thead>
                <tr>
                   <th class="header-cell w2"></th>
                   <th class="header-cell center w5" v-on:click="sortFunction('stageConfirmed')">Stage Conf</th>
                   <th class="header-cell center w5" v-on:click="sortFunction('emptyoutContainerNo')">Empty Pulled Win</th>
                   <th class="header-cell center w5" v-on:click="sortFunction('emptyoutContainerNo')">Ingate Rec Win</th>
                   <th class="header-cell center w5" v-on:click="sortFunction('emptyoutContainerNo')">Container No</th>
                   <th class="header-cell center w5" v-on:click="sortFunction('emptyoutChassisNo')">Chassis No</th>
                   <th class="header-cell center w5" v-on:click="sortFunction('stageCarrier')">Shipping Line</th>
                   <th class="header-cell center w5" v-on:click="sortFunction('MoveInDate')">Move In Date</th>
                   <th class="header-cell center w5" v-on:click="sortFunction('driverId')">Driver</th>
                   <th class="header-cell center w7" v-on:click="sortFunction('stageBookingNo')">Booking No</th>
                   <th class="header-cell center w7" v-on:click="sortFunction('emptyoutBookingNo')">Empty Pulled BK#</th>
                   <th class="header-cell center w7" v-on:click="sortFunction('{freightType')">Rate Type</th>
                </tr>
                </thead>
              </table>  
            </div>
            <div class="table-body" @scroll="handleScroll">
              <table id="bodytable" v-if="bobtailOnly == false">
                <tbody>
                  <tr :key="item.vueKey" v-for="item in pageItems" 
                        v-bind:class ="{ selected: item.selected }">
                   <td class="body-cell w2 ">
                    <md-checkbox v-model="item.selected">
                      <!--<span v-if="hasBeenChanged(item)">*</span>-->
                    </md-checkbox>
                  </td>
                  <td class="body-cell excelBox w5">{{ item.salesOffice }}</td>
                  <td class="body-cell excelBox w5">{{ item.receivingWindow}}</td>
                  <td class="body-cell excelBox w5">{{item.loadStatus}}</td>
                  <td class="body-cell excelBox w5">{{item.stageStatus}}</td>
                  <!--<td class="body-cell excelBox w5">{{item.seqNo}}</td>-->
                  <td class="body-cell excelBox w10">
                    <template v-if="isAsgDriver && chkItemPushStatus(item)">
                       <auto-complete-select
                                :options="drivers"
                                :value="item.driverId"
                                :on-item-change="changeAsgDriverId(item)"
                        ></auto-complete-select>        
                    </template>
                    <template v-else>
                    {{item.driverId}}
                    </template>
                  </td>
                  <template v-if="item.emptyContainer != null && item.emptyContainerNo != ''">
                     <td class="body-cell excelBox w8">{{item.emptyContainerNo}}</td>
                   </template>
                  <template v-else>
                     <td class="body-cell excelBox w8">{{item.containerNo}}</td>
                  </template>
                  <template v-if="item.emptyChassisNo != null && item.emptyChassisNo != ''">
                     <td class="body-cell excelBox w8">{{item.emptyChassisNo}}</td>
                  </template>
                  <template v-else>
                     <td class="body-cell excelBox w8">{{item.chassisNo}}</td>
                  </template>    
                  <td class="body-cell excelBox w5">{{item.carrier}}</td>
                  <td class="body-cell excelBox w5">{{item.stage}}</td>
                  <td class="body-cell excelBox w5">{{item.stageType}}</td>
                  <td class="body-cell excelBox w5">{{item.freightType}}</td>
                  <td class="body-cell excelBox w5">{{item.costRelevant}}</td>
                  <td class="body-cell excelBox w10">{{item.stageDispatcherInstruction}}</td>
                  <td v-if="item.mismatchBooking != true" class="body-cell excelBox w8">{{item.bookingNo}}</td>
                  <td v-if="item.mismatchBooking == true" class="body-cell excelBox w8 mismatch">{{item.bookingNo}}</td>
                  <td class="body-cell excelBox w8">{{item.emptyPulledBooking}}</td>
                  <td class="body-cell excelBox w5">
                      <md-checkbox v-model="item.mismatchBooking" disabled></md-checkbox>
                  </td>
                  <td class="body-cell excelBox w5">{{item.cutLFD | date}}</td>
                  <td class="body-cell excelBox w5">{{item.dropOffTml}}</td>
                  <td class="body-cell excelBox w5">{{item.appointment}}</td>
                  <td class="body-cell excelBox w10">{{item.apptDate | date}}</td>
                  <td class="body-cell excelBox w5">{{item.apptTime}}</td>
                  <td class="body-cell excelBox w5">{{item.driverGroup}}</td>
                  <td class="body-cell excelBox w5">{{item.driverId}}</td>
                  <td class="body-cell excelBox w10">
                    <template v-if="item.driverCntrImg != null">
                        <a href="" @click.prevent="toggleItemLink(item)">
                          1 image
                        </a>  
                      </template>  
                      <template v-else>
                          0 image
                      </template>  
                  </td>
                  <td class="body-cell excelBox w10">
                    <template v-if="item.needChassisAdditionPic == true && item.chassisPlusPhotoCount != null && (item.chassisPlusPhotoCount != '' && item.chassisPlusPhotoCount != '0')">
                        <a href="" @click.prevent="toggleItemPhoto(item,'CHASSIS PLUS')">
                          {{ item.chassisPlusPhotoCount }} image
                        </a>  
                      </template>  
                      <template v-else>
                          0 image
                      </template>  
                  </td>
                  <td class="body-cell excelBox w10">{{ item.chassisPlusPhotoBOL }}</td>
                  <td class="body-cell excelBox w10">{{getPushStatusInfo(item.pushStatus)}}</td>
                  <td class="body-cell excelBox w5">{{item.ctnrType}}</td>
                  <td class="body-cell excelBox w5">{{item.source}}</td>
                  <td class="body-cell excelBox w5">{{item.chzUseDay}} Days</td>
                  <td class="body-cell excelBox w5">{{item.manualchassisuseday}}</td>
                  <td class="body-cell excelBox w5">{{item.chzEndDate | date}}</td>
                  <td class="body-cell excelBox w5">{{item.loadKey}}</td>
                  <td class="body-cell excelBox w5">{{item.yardLoc}}</td>
                  <td class="body-cell excelBox w8">{{item.customerOrder}}</td>
                  <td class="body-cell excelBox w7">{{item.sealNumber}}</td>
                  <td class="body-cell excelBox w5">{{item.scaleTicket}}</td>
                  <td class="body-cell excelBox w5">{{item.pickupLoc}}</td>
                  <td class="body-cell excelBox w5">{{item.pickupTml}}</td>
                  <td class="body-cell excelBox w5">{{item.deliveryTo}}</td>
                  <td class="body-cell excelBox w5">{{item.truckId}}</td>
                  <td class="body-cell excelBox w10">{{item.dispatchInstuction}}</td>
                  <td class="body-cell excelBox w5">{{item.deliveryOrder}}</td>
                  <td class="body-cell excelBox w5">{{item.stcLoadConfirmedBy}}</td>
                  <td class="body-cell excelBox w5">{{item.stcLoadConfirmedAt | date}}</td>
                  <td class="body-cell excelBox w5">{{item.stcLoadConfirmedAt | time}}</td>
                  <td class="body-cell excelBox w5">{{item.stcStageConfirmedBy}}</td>
                  <td class="body-cell excelBox w5">{{item.stcStageConfirmedAt | date}}</td>
                  <td class="body-cell excelBox w5">{{item.stcStageConfirmedAt | time}}</td>
                  <!--
                  <td class="body-cell excelBox w5">
                     <md-checkbox v-model="item.stcDriverTasksConfirmed"></md-checkbox>
                  </td>
                  <td class="body-cell excelBox w5">{{ item.stcDriverTasksConfirmedAt }}</td>
                  <td class="body-cell excelBox w5">{{ item.stcDriverTaskConfirmedBy }}</td>
                  <td class="body-cell excelBox w5">
                     <template v-if="item.driverTaskConfirmSignImage != null && item.driverTaskConfirmSignImage != ''">
                        <a href="" @click.prevent="toggleItemPhoto(item, 'SIGN CONFIRM PHOTO')">1</a>
                     </template>
                  </td>
                  <td class="body-cell excelBox w5">{{ item.driverTaskConfirmKey }}</td>
                -->
                  <td class="body-cell excelBox w5">
                     <md-checkbox v-model="item.rateChanged" disabled></md-checkbox>
                  </td>
                  <td class="body-cell excelBox w5">
                     <md-checkbox v-model="item.stcDriverTaskPayConfirmed" disabled></md-checkbox>
                  </td>
                  <td class="body-cell excelBox w5">{{ item.stcDriverTasksPayConfirmedAt | date }}</td>
                  <td class="body-cell excelBox w5">{{ item.stcDriverTasksPayConfirmedAt | time }}</td>
                  <td class="body-cell excelBox w5">{{ item.stcDriverTaskPayConfirmedBy }}</td>
                  <td class="body-cell excelBox w5">
                     <template v-if="item.driverPayConfirmSignImage != null && item.driverPayConfirmSignImage != ''">
                        <a href="" @click.prevent="toggleItemPhoto(item, 'SIGN CONFIRM PAY PHOTO')">1</a>
                     </template>
                  </td>
                  <td class="body-cell excelBox w5">{{ item.driverPayConfirmKey }}</td>
                  <td class="body-cell excelBox w5">{{item.seqNo}}</td>
                  <td class="body-cell excelBox w5">{{item.route}}</td>



                  <!--<td class="body-cell excelBox w5" @click="toggleDispatch(item.seqNo)">{{item.seqNo}}</td>-->
                  <!--
                  <td class="body-cell excelBox w8" @click="togeditHideeContainerCopy(item.containerNo)">{{item.containerNo}}
                    <span v-if="containerCopy == true" class="popuptext" id="myPopup">Container No copied</span></td>
                    
                  <td class="body-cell excelBox w8" @click="toggleContainerCopy(item.chassisNo)"><div class = "spaceLine">{{item.chassisNo}}</div>
                  -->
                   <!-- <div>{{getChassisUsedDate(item.chzStartDate)}} Days</div> -->
                  <!-- 
                    <span v-if="containerCopy == true" class="popuptext" id="myPopup">Chassis No copied</span></td>
                  -->
                  <!--
                  <td  class="body-cell excelBox w8">{{item.containerNo}}</td>
                  <td  class="body-cell excelBox w8">{{item.chassisNo}}</td>
                  <td  class="body-cell excelBox w5">{{item.carrier}}</td>
                  <td  class="body-cell excelBox w5">{{item.grade}}</td>
                  <td  class="body-cell excelBox w5">{{item.bookingNo}}</td>
                  <td  class="body-cell excelBox w5">{{item.cutLFD}}</td>
                  <td class="body-cell excelBoxTB w5">
                    <template v-if="disableAppt">
                      {{item.appointment}}
                    </template>
                    <template v-else>
                     <md-field >
                      <md-input v-model="item.appointment"/>
                    </md-field>
                    </template>
                    
                  </td>
                  <td class="body-cell excelBox w8">
                    <template v-if="disableAppt">
                      {{item.apptDate | date}}
                    </template>
                    <template v-else>
                      <div style="min-width:160px">
                      <datepicker v-model="item.apptDate">
                    </datepicker>
                      </div>
                    </template>
                    </td>
                    <td class="body-cell excelBox w5">
                    <template v-if="disableAppt">
                      {{item.apptTime}}
                    </template>
                    <template v-else>
                       <md-field>
                        <md-input v-model="item.apptTime"/>
                      </md-field>
                    </template>
                    </td>
                  -->  
                  <!--<td class="body-cell excelBox w5">{{item.apptDate | time}}</td>-->
                  <!--
                  <td class="body-cell excelBox w5">
                    <template v-if="isSetDriverGroup">
                        <md-field >
                          <md-input v-model="item.driverGroup"
                          />
                        </md-field>
                      </template>
                      <template v-else>
                        {{ item.driverGroup }}
                      </template>
                  </td>
                  <td class="body-cell excelBox w10">
                    <template v-if="isAsgDriver">
                      <auto-complete-master-data-select
                                              :prepared-options="drivers"
                                              :init-value="item.driverId"
                                              :on-item-changed="item.driverId"
                                              >
                      </auto-complete-master-data-select>

                    </template>
                      <template v-else>
                        {{ item.driverId }}
                      </template>

                  </td>
                  <td class="body-cell excelBox w5">{{item.truckId}}</td>
                -->
                  <!--<td class="body-cell excelBox w10">{{item.driverCntrImg}}</td>-->
                  <!--
                  <td class="body-cell excelBox w10">
                      <template v-if="item.driverCntrImg != null">
                        <a href="" @click.prevent="toggleItemLink(item)">
                          1 image
                        </a>  
                      </template>  
                      <template v-else>
                          0 image
                      </template>  
                  </td>
                  <td class="body-cell excelBox w10">{{item.driverRemark}}</td>
                  <td class="body-cell excelBox w10">{{getPushStatusInfo(item.pushStatus)}}</td>
                  <td  class="body-cell excelBox w5">{{item.ctnrType}}</td>
                  <td  class="body-cell excelBox w5">{{item.source}}</td>
                  <td  class="body-cell excelBox w5">{{getChassisUsedDate(item)}} Days</td>
                  <td  class="body-cell excelBox w5">{{item.chzEndDate}}</td>
                  <td  class="body-cell excelBox w5">
                    <a href="" @click.prevent="doSingleDispatch(item)">{{item.loadKey}}</a>
                  </td>
                  <td  class="body-cell excelBox w5">{{item.seqNo}}</td>
                  <td  class="body-cell excelBox w10"><div class = "spaceLine">{{item.yard}} {{item.locationNumber}}</div></td>
                  <td  class="body-cell excelBox w5">{{item.customerOrder}}</td>
                  <td  class="body-cell excelBox w5">{{item.sealNumber}}</td>
                  <td  class="body-cell excelBox w5">{{item.scaleTicket}}</td>
                  <td  class="body-cell excelBox w5">{{item.pickUpLocationName}}</td>
                  <td class="body-cell excelBox w10">
                      <master-data-display group="GST_LOCATION" :tag-id="item.deliverLocationCode"/>
                  </td>
                  <td class="body-cell excelBox w7">
                      <master-data-display group="GST_TERMINAL" :tag-id="item.pickupTerm"/>
                  </td>
                  <td class="body-cell excelBox w5">{{item.deliveryOrder}}</td>-->
                  <!--<td class="body-cell excelBox w5">{{item.deliveryOrderItem}}</td>-->
                  <!--
                  <td class="body-cell excelBox w5"> {{item.route}}</td>
                   <td class="body-cell excelBox w10"> {{item.routeDesc}}</td>
                  -->


<!--
                  <td  class="body-cell excelBox w5">{{item.stage}}</td>
                  <td  class="body-cell excelBox w5">{{item.stageType}}</td>
-->                    
                  <!-- <td  class="body-cell excelBox w5">{{item.pickupLoc}}</td>
                  <td  class="body-cell excelBox w5">{{item.deliveryTo}}</td> -->
<!--                    
                  <td class="body-cell excelBox w15">
                    <autocomplete-ccic-location-select
                        v-if="item.editing"
                        v-model="item.pickupLocationCode"
                        group="GST_LOCATION"
                        :on-item-selected="handlePickLocationChanged(item)"
                    />
                    <template v-else>{{item.pickupLocationCode}}</template>
                    </td>
                    <td class="body-cell excelBox w10">
                      <master-data-display group="GST_LOCATION" :tag-id="item.pickupLocationCode"/>
                    </td>
                  <td class="body-cell excelBox w15">
                    <autocomplete-ccic-location-select
                        v-if="item.editing"
                        v-model="item.deliverLocationCode"
                        group="GST_LOCATION"
                        :on-item-selected="handleDeliverLocationChanged(item)"
                    />
                    <template v-else>{{item.deliverLocationCode}}</template></td>
                    <td class="body-cell excelBox w10">
                      <master-data-display group="GST_LOCATION" :tag-id="item.deliverLocationCode"/>
                    </td>
                  <td class="body-cell excelBox w10" @click="toggleInstruction(item)">
                      {{item.dispatcherInstruction}}
           
                    
                    </td>
                  <td class="body-cell excelBox w5">
                    <template v-if="!item.editing">
                      {{item.costRelevant}}
                    </template>
                    <template v-else>
                     <md-field >
                      <md-input v-model="item.costRelevant"/>
                    </md-field>
                    </template>
                    
                    </td>
                  <td class="body-cell excelBox w5">{{item.source}}</td>
                  <td class="body-cell excelBox w5">
                    <template v-if="!item.editing">
                      {{item.freightType}}
                    </template>
                    <template v-else>
                     <md-field >
                      <md-input v-model="item.freightType"/>
                    </md-field>
                    </template>
                    
                    </td>
                  <td class="body-cell excelBox w5">{{item.chzStartDate | date}}</td>
                  <td class="body-cell excelBox w5">{{item.pickupDate | date}}</td>
                  <td class="body-cell excelBox w5">{{item.customerRef}}</td>
                   <td class="body-cell excelBox w8">{{item.createdBy}}</td>
                  <td class="body-cell excelBox w8">{{item.createdAt | date}}</td>
                  <td class="body-cell excelBox w8">{{item.updatedBy}}</td>
                  <td class="body-cell excelBox w8">{{item.updatedAt | date}}</td>
                  <td class="body-cell excelBox w8">{{item.grade}}</td>
                  <td class="body-cell excelBox w8">
                     <template v-if="item.weight != 'null'">
                        {{item.weight}}
                     </template>
                  </td>
                  <td class="body-cell excelBox w8">{{item.sapStatus}}</td>
--> 
                 </tr>

                </tbody>
              </table>
              <table id="bodytable" v-if="bobtailOnly == true">
                <tbody>
                  <tr :key="item.vueKey" v-for="item in pageItems" 
                        v-bind:class ="{ selected: item.selected }">
                      <td class="body-cell excelBox w2">
                        <md-checkbox v-model="item.selected">
                        </md-checkbox></td> 
                      <td class="body-cell excelBox w5">
                        <md-checkbox v-model="item.stageConfirmed" disabled>
                        </md-checkbox>
                      </td>
                      <td class="body-cell excelBox w5">{{ item.receivingWindow }}</td>
                      <td class="body-cell excelBox w5">{{ item.emptyoutReceivingWindow }}</td>
                      <td class="body-cell excelBox w5">{{item.containerNo}}</td>
                      <td class="body-cell excelBox w5">{{item.chassisNo}}</td>
                      <td class="body-cell excelBox w5">{{item.stageCarrier}}</td>
                      <td class="body-cell excelBox w5">{{item.moveInDate | date}}</td>
                      <td class="body-cell excelBox w5">{{item.driverId}}</td>
                      <td class="body-cell excelBox w7">{{item.emptyoutBookingNo}}</td>
                      <td class="body-cell excelBox w7">{{item.stageBookingNo}}</td>
                      <td class="body-cell excelBox w7">{{getMasterDataByName('GST_RATE_COST',item.freightType)}}</td>
                  </tr>
                </tbody>
              </table>          

            </div>
          </div>
        </div>
      </md-card>
    </template>
  </pagination>
  </div>





</template>


<style scoped>
.popup {
position: relative;
display: inline-block;
cursor: pointer;
-webkit-user-select: none;
-moz-user-select: none;
-ms-user-select: none;
user-select: none;
}
.spaceLine {
margin-bottom: 10px;
}
.popuptext {
visibility: show;
width: 160px;
background-color: #555;
color: #fff;
text-align: center;
border-radius: 6px;
padding: 8px 0;
position: absolute;
z-index: 10;
bottom: 125%;
left: 50%;
margin-left: -80px;
}
.excelBox {
  padding-top: 5px;
  padding-bottom: 5px;
  padding-left: 5px;
  padding-right: 5px;
  text-align: center;
}
.excelBoxTB {
  padding-top: 5px;
  padding-bottom: 5px;
  padding-left: 5px;
  padding-right: 5px;
  text-align: center;
  margin-right: 5px;

}
.excelBoxLeft {
  padding-top: 5px;
  padding-bottom: 5px;
  padding-left: 5px;
  padding-right: 5px;
}
.material-icons.md-18 { font-size: 18px; }
.material-icons.md-24 { font-size: 24px; }
.material-icons.md-36 { font-size: 36px; }
.material-icons.md-48 { font-size: 100px; }
.material-icons.md-light { color: rgba(255, 255, 255, 1); }
.material-icons.md-light.md-inactive { color: rgba(255, 255, 255, 0.3); }
.icons-center {
  vertical-align: middle;
  margin-right: 10px;
}
.inputBox {
  border: 1px solid #cacbcc;
  border-radius: 5px;
  color: #29303b;
  font-size: 18px;
  height: auto;
  line-height: 1em;
  padding: 5px 5px 5px 5px;
  margin-top: 6px;
}
.inputBox:hover {

  border: 2px solid #448aff;
  border-radius: 5px;
  color: #29303b;
  font-size: 18px;
  height: auto;
  line-height: 1em;
  padding: 5px 5px 5px 5px;
  margin-top: 6px;
  background-color: #e0eff7;
    
}
.selected {
   background: #c8e6f5;
}
.tableW {
  height: 40px;
}
.center {
  text-align: center;
}

tr:hover {
  background: #c8e6f5;
}

.headerCenter {
  text-align: center;
}
.modal {
   background-color: #29303b;
    border-radius: 5px;
}
.modalTitle {
  font-weight: normal;
  font-family: 'UberMove', 'Open Sans', 'Helvetica Neue', Helvetica, sans-serif !important;
  font-weight: 500;
  color: white;
  font-family: Poppins, sans-serif;
  margin-bottom: 0.5rem;
  line-height: 1.6;
}
.md-menu {
padding: 0;
padding: 0;

}
.custButton {
  margin: 10px;
  width: 90px;
  height: 36px;
  line-height:20px;
  font-size: 0.8rem;
}
.custMedButton {
  margin: 10px;
  width: 110px;
  height: 36px;
  line-height:20px;
  font-size: 0.8rem;
}
.custMenuButton {
  
  width: 110px;
  height: 40px;
  line-height:45px;
  font-size: 0.9rem;
  align-self: center;
}
.custSearchBar{
    margin: 10px;
  width: 200px;
  height: 40px;
  line-height:40px;
  font-size: 0.9rem;
}
.custButtonRight {
  margin: 10px;
  width: 100px;
  height: 40px;
  float : right;
}
.result-included-inner-div-radio {
  margin-left: 5px;
  margin-bottom: -25px;
  margin: -12px;
}
.result-included-span-radio {
  font-weight: bold;
  margin-left: 12px;
  margin-right: 12px;
  position:relative;
  top: -5px;
}
.result-included-outter-div {
  border: 1px solid #D0D0D0;
  border-radius: 5px;
  width: 600px;
  padding: 10px;
  height: 43px;
  margin-top: 5px;
  margin-bottom: 5px;
  margin-left: 20px;
}
.mismatch {
  color: red;
}

</style>



<script>
/* eslint-disable no-plusplus */
import { mapGetters } from 'vuex';
import dateFormat from '../utils/dateFormat';
import toGenerateExcelRequest, { downloadExcel } from "../utils/excel";
//import api from "../api";
import { newAPIPost } from '../api/index.js';
import UpdateCcicContainerStatusForm from "../components/UpdateCcicContainerStatusForm.vue";
import CcicPhotoForm from "../components/CcicPhotoForm.vue";
import MoveCcicContainerForm from "../components/MoveCcicContainerForm.vue";
import parseXls from "../utils/parseXls";
import callingApiCenter from "../components/CallingApiCenter.vue";
import YardExportForm from '../components/YardExportForm.vue';
import DispatchForm from '../components/DispatchForm.vue';
import AutocompleteCcicLocationSelect from "../components/AutocompleteCcicLocationSelect.vue";
import AutoCompleteStcDriverGroupSelect from '../components/AutoCompleteStcDriverGroupSelect.vue';
import OutboundBooking from '../components/OutboundBooking.vue';


const getInitSearch = () => ({
  users: [],
  teams: [],
  receivingWindow: null,
  salesOffice: null,
  pickupLocation: null,
  bookingNo: null,
  destination: null,
  appointment: null,
  driverId: null,
  driverGroup: null,
  costRelevant: null,
  freightType: null,
  // chzStartDate: {
  //   startDate: null,
  //   endDate: null,
  // },

  cargoCutOff: {
    startDate: null,
    endDate: null,
  },
  apptDate: {
    startDate: null,
    endDate: null,
  },
  moveInDate: {
    startDate: null,
    endDate: null,
  },
  inGateDate: {
    startDate: null,
    endDate: null,
  },
  // pickupDate: {
  //   startDate: null,
  //   endDate: null,
  // },

  seqNo: [],
  loadKey: null,
  source: null,
  containerNo: null,
  chassisNo: null,
  carrier: null,
  //yard: null,
  //locationNumber: null,
  customerOrder: null,
  deliveryOrder: null,
  //route: null,
  //locCode:null,
  //group:null,
  //locName: null,
  loadStatus: ['LD', 'ASN'],
  //selected: false,
  pushStatus: null,
  stageType: null,
  bobtailOnly: null,
  forStage: true
});

const initSearchCriteria = () => ({
    receivingWindow: null,
    salesOffice: null,
    pickupLocation: null,
    bookingNo: null,
    destination: null,
    appointment: null,
    driver: null,
    driverGroup: null,
    costRelevant: null,
    freightType: null,
    cargoCutOff: {
      startDate: null,
      endDate: null,
    },
    apptDate: {
      startDate: null,
      endDate: null,
    },
    moveInDate: {
      startDate: null,
      endDate: null,
    },
    inGateDate: {
      startDate: null,
      endDate: null,
    },
    loadKey: null,
    source: null,
    containerNo: null,
    chassisNo: null,
    carrier: null,
    customerOrder: null,
    deliveryOrder: null,
    loadStatus: [],
    pushStatus: null,
    stageType: null,
    filter: "",
    fromPage: null
 
})

const initDispatchLoadSearch = () => ({
    receivingWindow: null,
    salesOffice: null,
    pickupLocation: null,
    bookingNo: null,
    destination: null,
    appointment: null,
    driverId: null,
    driverGroup: null,
    costRelevant: null,
    freightType: null,
    cargoCutOff: {
      startDate: null,
      endDate: null,
    },
    apptDate: {
      startDate: null,
      endDate: null,
    },
    moveInDate: {
      startDate: null,
      endDate: null,
    },
    inGateDate: {
      startDate: null,
      endDate: null,
    },
    loadKey: null,
    source: null,
    containerNo: null,
    chassisNo: null,
    ctnrType: null,
    carrier: null,
    customerOrder: null,
    deliveryOrder: null,
    loadStatus: [],
    pushStatus: null,
    stageType: null,
    filter: null,
    fromPage: null,
    selectDType: null
})

const initCockpitReq = () => ({
   mode: null,
   carrierName: null,
   customerOrder: null,
   route: null,
   deliveryOrder: null,
   loadKey: null,
   bookingNo: null
})

const getInitDriverSearch = () => ({
     source: null,
     driverOffice: null,
     defaultSalesOffice: null
  })

const initStageSearch = () => ({
    loadKey: null,
    seqNo: null
})

export default {

  data: () => ({
    searchRequest: getInitSearch(),
    cockpitRequest: initCockpitReq(),
    searchDriverSearchReq: getInitDriverSearch(),
    searchCriteria: initSearchCriteria(),
    searchStage: initStageSearch(),
    dispatchLoadSearch: initDispatchLoadSearch(),
    active: false,
    drivers: [],
    items: [],
    selectedItems: [],
    dialog: {
      isShowing: false,
    },
    usersToSearch: [],
    modalMessage: "",  
    isWarning: false,
    active: false,
    sortStatus: true,
    filter: "",
    containerCopy: false,
    selectAll: false,
    notifyMessage: null,
    notifyActive: false,
    selectDType: "YE",
    isPictureModalShowing: false,
    photoZipFileName: '',
    filePrefixForEachFile: '',
    isLoading: false,
    isdownloadzip: false,
    imgPath: null,
    photoTitle: "Photos",
    photos: [],
    singleReq: [],
    driverGroups: [],
    stcDriverGroups: [],
    stcDriverGroupOption: [],
    driverIds: [],
    driverNames: [],
    driverContent: [],    
    isSetDriverGroup: false,
    isSetAppointment: false,
    isAsgDriver: false,
    disableSave: false,
    disableAppt: true,
    driverIds: [],
    driverNames: [],
    driverContent: [],
    stageList: [],
    isPictureModalShowing3: false,
    isChassisPictureModalShowing: false,
    signURL: null,
    bobtailOnly: false,
    chassisPlus: false,
    bobtailEmptyItems: [],
  }),


  components: {
    AutocompleteCcicLocationSelect,
    AutoCompleteStcDriverGroupSelect,
    MoveCcicContainerForm,
    UpdateCcicContainerStatusForm,
    CcicPhotoForm,
    callingApiCenter,
    YardExportForm,
    DispatchForm,
    OutboundBooking,

  },

  watch: {
    // getYardExportList(val) {
    //   this.updateItems(val);
    // },
    // getDirectExportList(val) {
    //   this.updateItems(val);
    // },
    // getTruckLoadList(val) {
    //   this.updateItems(val);
    // },
    // getImportLoadList(val) {
    //   this.updateItems(val);
    // },

    getDispatchStageList(val) {
        this.updateItems(val);
    },

    // eslint-disable-next-line
    "searchRequest.teams"() {
       this.searchRequest.users = [];
    },
    notifyActive(val) {
      if (val == false)
      {
        this.notifyMessage = null;
      }
    },

  },

  computed: {
  ...mapGetters([
      'getMasterDataName',
      'getMasterDataByGroup',
      'getMasterDataAsSelectOptionByGroup',
      'getPermission',
      'getUserProfile',
      'getRole',
      'getYardExportList',
      'getImportLoadList',
      'getTruckLoadList',
      'getSTCDriverGroup',
      'getDirectExportList',
      'getDispatchStageList'
    ]),


    filteredRows(){
      console.log( `first item: ${JSON.stringify(this.items[0])}`);
      var items = this.items;
      if (this.bobtailOnly)
      {
          items = items.filter((it) => (it.freightType == 'CD27' || it.freightType == 'CD06'))
      }
      if (this.chassisPlus)
      {
          items = items.filter((it) => it.needChassisAdditionPic == true)
      }
      //return this.items.filter(row => {
      return items.filter(row => {
        const term = this.filter.toUpperCase();
        return this.includeNull(row.containerNo).includes(term) ||
               this.includeNull(row.chassisNo).includes(term) ||
              //  this.includeNull(row.loadKey).includes(term)||
               this.includeNull(row.seqNo).includes(term)||
               this.includeNull(row.loadStatus).includes(term)||
               this.includeNull(row.stageStatus).includes(term)||
               this.includeNull(row.stageType).includes(term)||
               this.includeNull(row.bookingNo).includes(term)||
               this.includeNull(row.chassisPlusPhotoBOL).includes(term);
      })
    },



    getSelectedItems() {
      return _(this.items)
        .filter(it => it.selected);
    },

    getEditingItems() {
      return _(this.items)
        .filter(it => it.editing);
    },

    getAssignBookingCond() {

      // const items = _(this.items).filter((it) => it.selected);
      // const LD = _(this.items).filter((it) => it.loadStatus == 'ASN');
      // if (LD.length != 0) return false;
      // const weighted = _(items).filter((it) => it.weight != 'null');
      // if (items.length == 0) return false
      // const ctnrType = [...new Set(items.map(s => s.ctnrType))];
      // const grade = [...new Set(items.map(s => s.grade))];
      // const carrier = [...new Set(items.map(s => s.carrier))];
      // // carrier.length === 1
      // const sapStatus = _(this.items).filter((it) => it.sapStatus != 'X');
      // if (sapStatus.length == 0) return false
      // console.log("grade: " + grade + " grade length: " + grade.length + ":" + this.isValidCond(grade) + " ctnrType: " + ctnrType + "ctnrType length: " + ctnrType.length + ":" + this.isValidCond(ctnrType) + " weight: " + weighted + ":" + weighted.length);
      // //return items.length === weighted.length && ctnrType.length === 1 && grade.length === 1
      // return items.length === weighted.length && this.isValidCond(ctnrType) && this.isValidCond(grade);
      const items = _(this.items).filter((it) => it.selected);
      //const LD = _(this.items).filter((it) => it.loadStatus == 'ASN');
      const LD = items.filter((it) => it.loadStatus == 'ASN');
      if (LD.length != 0) return false;
      const weighted = _(items).filter((it) => it.weight != null);
      if (items.length == 0) return false
      const ctnrType = [...new Set(items.map(s => s.ctnrType))];
      const grade = [...new Set(items.map(s => s.grade))];
      const carrier = [...new Set(items.map(s => s.carrier))];
      // carrier.length === 1
      const sapStatus = _(this.items).filter((it) => it.sapStatus != 'X');
      if (sapStatus.length == 0) return false
      //console.log("grade: " + grade + ":" + grade.length + " ctnrType: " + ctnrType + ":" + ctnrType.length);
      return items.length === weighted.length && ctnrType.length === 1 && grade.length === 1

    },

    getUnAssignBookingCond() { 
       //console.log("unassign cond");
       const item = _(this.items).filter((it) => it.selected);
       const sapStatus = _(this.items).filter((it) => it.sapStatus != 'X');
       if (sapStatus.length == 0) return false
       //console.log("unassign item length:" + item.length);
       return item.length === 1 && item[0].loadStatus == 'ASN'
    },

    getSelectedItems() {
      return _(this.items).filter((it) => it.selected);
    },


    canOutGate(){
      return this.getSelectedItems.length != 0
    },


    canEditSingle() {
       return this.getSelectedItems.length === 1 ;
      
       //return this.getSelectedItems.length === 1 ;
    },

    canEditSingle() {
       return this.getSelectedItems.length === 1 ;
      
       //return this.getSelectedItems.length === 1 ;
    },


    canEdit() {
      return this.getSelectedItems.length != 0 ;
    },


    canSave() {
      //console.log("canSave: " + this.disableSave);
      return this.disableSave;
    },

    noGates(){
        if (this.getSelectedItems.length == 0)
        {
          return false
        }
        var gates = false
        this.getSelectedItems.forEach((it) => {
          if (it.loadKeyWithStageNo == null)
          {
            gates = true
          }
        });
        return !gates;
    },

    // canSave() {
    //   return !!_(this.getEditingItems)
    //     .find(it => !!this.hasBeenChanged(it));
    // },


    canDelete(){

      
      if (this.getSelectedItems.length != 1)
      {
        return false
      }

      if (this.getSelectedItems[0].stageStatus != null)
      {
        return false
      }

      return true


    },

    canDeleteBooking() {
      if (this.getSelectedItems.length != 1)
      {
        return false
      }

      if (this.getSelectedItems[0].deliveryOrder == null)
      {
        return false
      }

      return true
    },


    canDeleteLoad(){

      
      if (this.getSelectedItems.length != 1)
      {
        return false
      }

      if (this.getSelectedItems[0].stageStatus != null)
      {
        return false
      }

      if (this.getSelectedItems[0].loadStatus != "JO")
      {
        return false
      }

      return true


    },

    getDownloadCond() {
        const item = _(this.items).filter((it) => it.selected);
        if (item.length == 0 && this.items.length != 0) return this.items;

    },


  },

  async mounted() {
    
    this.drivers = [];
    var seqNos = [];
    //console.log("location")
    //console.log(this.getMasterDataAsSelectOptionByGroup('GST_LOCATION'))
    // this.$store.dispatch('getUsersByCategory', { category: 'L' })
    //   .then((res) => {
    //     this.drivers = res;

    //   });
    this.searchRequest.moveInDate.endDate = this.getDateDiffForDatePicker(Date(),0);
    this.searchRequest.moveInDate.startDate = this.getDateDiffForDatePicker(Date(), 31); 
    //this.searchRequest.inGateDate.startDate = "";
    //this.searchRequest.inGateDate.endDate = "";

      console.log("search req: " + JSON.stringify(this.$route.params.req));
      console.log("search criteria: " + JSON.stringify(this.$route.params.searchCriteria));
      //if (this.$route.params.req) {
        
         //var searchCriteria = JSON.parse(this.$route.params.req);
         if (this.$route.params.req) {
            var loadlist = JSON.parse(this.$route.params.req);
            loadlist.forEach( it => {seqNos.push(it.seqNo)});
            if (seqNos && seqNos.length > 1) {
               this.searchStage.loadKey = seqNos[0];
            }
         }
         if (this.$route.params.searchCriteria) {
            var searchCriteria = JSON.parse(this.$route.params.searchCriteria);
            this.loadAndSaveLoadSearchCriteria(searchCriteria);
            this.setStageSearchFromLoad();
         }
        //  if (searchCriteria && searchCriteria.length > 0) {
        //     this.searchStage.loadKey = searchCriteria[0].loadKey;
        //     console.log("searchCriteria: " + JSON.stringify(searchCriteria));
        //     console.log("from page: " + searchCriteria.fromPage);
        //     // if (this.dispatchLoadSearch && this.dispatchLoadSearch.fromPage == "L")
        //     //    this.stageList.forEach( it => {seqNos.push(it.seqNo)}); //for the case load <=> stage
        //  }
         this.searchDriverSearchReq.driverOffice = "STC";
         this.searchDriverSearchReq.defaultSalesOffice = "LGB";
         this.$store.dispatch('gstDriverMaster', this.searchDriverSearchReq);
         //console.log("getGSTDriverMaster: " + JSON.stringify(this.getGSTDriverMaster));
         this.updateDrivers(this.getGSTDriverMaster); 

         console.log('get driver group in dispatch stage');
         this.$store.dispatch('stcDriverGroup', this.searchDriverGroupReq);
         //await api.post('/api/w/stc/WebSearchDriverGroup', this.searchDriverGroupReq).then((driverGroup) => {
         await newAPIPost('/api/w/stc/WebSearchDriverGroup', this.searchDriverGroupReq).then((driverGroup) => {
                this.stcDriverGroups = driverGroup;
         })
         console.log(`stc driver group: ${JSON.stringify(this.stcDriverGroups)}`);
         if (this.stcDriverGroups) {
           this.stcDriverGroups.forEach( (val) => {
              const p_driverGrp = this.stcDriverGroupOption.filter( it => it === val.driverGroup);
              if (p_driverGrp.length == 0)
                 this.stcDriverGroupOption.push(val.driverGroup);
         })
          
        }      

         console.log('check and click expend-button'); 
         this.searchRequest.salesOffice = this.getUserProfile.driverGroup;
         console.log("pass to stage seqNo: " + seqNos);
         this.searchRequest.seqNo = seqNos;
         this.$nextTick(() => {
           if (this.$el && this.$el.querySelector && this.$el.querySelector('#expand-button'))
           {
              this.$el.querySelector('#expand-button').click();
           }
         });
         //console.log("searchStage loadKey: " + this.searchStage.loadKey);

        //  if (this.searchStage.loadKey != null) 
        //     this.searchRequest.loadKey = this.searchStage.loadKey;
         //else 
         //   this.searchRequest.seqNo = this.searchStage.seqNo;   
        //  if (this.dispatchLoadSearch.loadStatus && this.dispatchLoadSearch.loadStatus != "") {
        //     this.searchRequest.loadStatus = this.dispatchLoadSearch.loadStatus;
        //  }
         const cachedSearchRequest = this.$store.state.dispatchStageList.searchRequest;
         console.log('check and click searchtag');
         this.$nextTick(() => {
           if (this.$el && this.$el.querySelector && this.$el.querySelector('#searchTag')) {
              this.$el.querySelector('#searchTag').click();
           }
         });
         //console.log("DispatchStageList");
         this.updateItems(this.getDispatchStageList);
         this.disableSave = true;
         this.isSetAppointment = false;
         this.isSetDriverGroup = false;
         this.isAsgDriver = false;
         this.disableAppt = true;
      
   },

   methods: {

    handleOfficeChanged(id) {
      this.searchRequest.salesOffice = id;
    },

    sortFunction(sortFiled){
              const nullValues = _.filter(this.items, (item) => {
                return item[sortFiled] == null
              })
              const values = this.items.filter(it => it[sortFiled] != null);
              const sorted = _.sortBy(values,sortFiled).concat(nullValues);
              this.sortStatus = !this.sortStatus;
              if (this.sortStatus)
              {
                  this.items = sorted;
              }
              else
              {
                  this.items = sorted.reverse();
              }
        },



    handleWindowsChanged(id) {
      this.searchRequest.receivingWindow = id;
    },
    handleDrGroupChanged(id) {
      this.searchRequest.driverGroup = id;
    },
    handleStageStatusChanged(id) {
      this.searchRequest.stageStatus = id;
    },
    handleCtnrTypeChanged(id) {
      this.searchRequest.ctnrType = id;
    },
    handleSearchDriverChanged(id) {
      //console.log("handlesearchdriverchange id: " + id);
      this.searchRequest.driverId = id;
    },
    handleFreightTypeChanged(id) {
        this.searchRequest.freightType = id;
    },
    
    toggleContainerCopy(element){
        this.containerCopy = true;
        setTimeout(() => {  this.containerCopy = false; }, 2000);
        var el = document.createElement('textarea');
        el.value = element;
        el.setAttribute('readonly', '');
        el.style = {position: 'absolute', left: '-9999px'};
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
    },

    toggleDispatch(element) {
        alert("call to pop-up dispatch" + element);
    },

    updateItems(itemsSource) {
        var items = JSON.parse(JSON.stringify(itemsSource));
        const stageconfirmed = ['CFM','BLC','LOK','CCO'];
        items.forEach((it) => {
          it.backGroud = false;
          it.selected = false;
          it.editing = false;
          it.stageConfirmed = stageconfirmed.includes(it.stageStatus);
        });
        this.items = [];
        this.items = items;
        if (this.notifyMessage != null)
        {
          this.notifyActive = true;
          
        }

     },

    getPhotoName(photo) {
        const photoName = decodeURI(photo.imgUrl.replace(/.*\//g, ""));
        return `${this.filePrefixForEachFile || ''}${photoName}`;
    },

    getChassisPhotoName(photo) {
        const photoName = decodeURI(photo.photoUrl.replace(/.*\//g, ""));
        return `${this.filePrefixForEachFile || ''}${photoName}`;
      },

    async toggleItemPhoto(item, status) {
        this.gateStatus = status;
        //this.photos = item
        // this.photoZipFileName = `${item.application.bookingNo}_${item.application.poNo}_${item.containerNo}.zip`;
        // this.filePrefixForEachFile = `${item.containerNo}-`;
        //this.photoZipFileName = `${item.application.bookingNo}_${item.application.poNo}_${item.containerNo}.zip`;
        // this.filePrefixForEachFile = `${item.containerNo}-`;
        if (status == "IN GATE PHOTO" || status == "OUT GATE PHOTO")
        {
           this.isPictureModalShowing = true;
           //await api.post("/api/w/ccic/photo/getInOutGate", {containerSeqNo:item.seqNo}).then(
           await newAPIPost("/api/w/ccic/photo/getInOutGate", {containerSeqNo:item.seqNo}).then(
             (val) => {
                if (status == "IN GATE PHOTO") {
                   this.photos = val.ingatephoto
                } else if (status == "OUT GATE PHOTO") {
                   console.log("photolist: " + JSON.stringify(val.outgatephoto));
                   this.photos = val.outgatephoto
             }
          })
        }
        else if (status == "LOADING PHOTO") 
        {
           this.isPictureModalShowing2 = true;
           this.isLoading = true;
           //this.photos = (await api.post('/api/w/ccic/photo/get', { containerSeqNo: item.seqNo, outboundLoadingPic: true }))
           this.photos = (await newAPIPost('/api/w/ccic/photo/get', { containerSeqNo: item.seqNo, outboundLoadingPic: true }))
               .filter(it => this.loadpickeys.includes(it.photoKey));
           if (item.bookingNo != null)
             this.photoZipFileName = `${item.seqNo}_${item.bookingNo}_${item.containerNo}.zip`;
           else
             this.photoZipFileName = `${item.seqNo}_${item.containerNo}.zip`;
           this.filePrefixForEachFile = `${item.containerNo}-`;
           console.log(this.photos)    
        }
        else if (status == 'SIGN CONFIRM PHOTO' || status == 'SIGN CONFIRM PAY PHOTO')
        {
           this.isPictureModalShowing3 = true;
           if (status == 'SIGN CONFIRM PHOTO')
           {
              this.signURL = item.driverTaskConfirmSignImage;
           } else {
              this.signURL = item.driverPayConfirmSignImage;
           }
        }
        else if (status == 'CHASSIS PLUS')
        {
           this.isChassisPictureModalShowing = true;
           this.isLoading = true;
           //this.photos = (await api.post('/api/w/ccic/photo/get', { containerSeqNo: item.seqNo, outboundLoadingPic: true }))
           //this.photos = (await newAPIPost('/api/w/ccic/photo/chassisPlus', { containerSeqNo: item.seqNo }))
           //    .filter(it => this.loadpickeys.includes(it.photoKey));
           const chassispic = (await newAPIPost('/api/w/ccic/photo/chassisPlus', { containerSeqNo: item.seqNo }))
           console.log(`chassispic before process: ${JSON.stringify(chassispic)}`);
           chassispic.chassisphoto.forEach((it) => {
               it.imgUrl = it.photoUrl;
               this.photos.push(it);
           });
           console.log(`chassis photo length: ${this.photos.length}`);
           //if (item.bookingNo != null)
           //  this.photoZipFileName = `${item.seqNo}_${item.bookingNo}_${item.containerNo}.zip`;
           //else
           this.photoZipFileName = `${item.seqNo}_${item.containerNo}.zip`;
           this.filePrefixForEachFile = `${item.containerNo}-`;
           console.log(`chassis plus photos: ${JSON.stringify(this.photos)}`)

        }
      },


    async updateDrivers(itemsSource) {
          // console.log("update drivers itemsource: " + JSON.stringify(itemsSource));
          // var items = JSON.stringify(itemsSource);
          // var items1 = JSON.parse(items);
          // console.log("update drivers: " + items + ", " + items1);
          // // items.forEach(it => {
             
          // // })
          // console.log("items1 length: " + items1.length);
          // items1.forEach((it) => {
          //    console.log("items: " + JSON.stringify(it.shortId));
          //    var driverinfo = JSON.stringify(it.shortId);
          //    this.drivers.push(driverinfo);
          // })
          // //this.drivers = items;
          // console.log("drivers: " + this.drivers);
          
          //await api.post('/api/w/gstMasterData/driverMasterData', this.searchDriverSearchReq)
          await newAPIPost('/api/w/gstMasterData/driverMasterData', this.searchDriverSearchReq)
                 .then ( (driverinfo) => {
                    if (driverinfo) {
                        driverinfo.forEach( (it) => {
                            //console.log("driver: " + it.shortId);
                            var driverInfo = it.shortId + "(" + it.userName + ")";
                            this.drivers.push(driverInfo);
                            this.driverIds.push(it.driverId);
                            this.driverNames.push(it.userName);
                            this.driverContent.push(driverInfo);
                        })
                    }
                 });
          //console.log("drivers: [[" + this.drivers + "]]");
    },

    loadAndSaveLoadSearchCriteria(searchCriteria) {
        if (searchCriteria) {
            console.log("loadandsaveloadsearchcriteria: " + JSON.stringify(searchCriteria));
            this.dispatchLoadSearch.containerNo = searchCriteria.containerNo;
            this.dispatchLoadSearch.receivingWindow = searchCriteria.receivingWindow;
            this.dispatchLoadSearch.salesOffice = searchCriteria.salesOffice;
            this.dispatchLoadSearch.pickUpLocation = searchCriteria.pickUpLocation;
            this.dispatchLoadSearch.bookingNo = searchCriteria.bookingNo;
            this.dispatchLoadSearch.destination = searchCriteria.destination;
            this.dispatchLoadSearch.appointment = searchCriteria.appointment;
            this.dispatchLoadSearch.driveId = searchCriteria.driverId;
            this.dispatchLoadSearch.driverGroup = searchCriteria.driverGroup;
            this.dispatchLoadSearch.costRelevant = searchCriteria.costRelevant;
            this.dispatchLoadSearch.freightType = searchCriteria.freightType;
            if (searchCriteria.cargoCutOff != null && searchCriteria.cargoCutOff.startDate != null) {
               this.dispatchLoadSearch.cargoCutOff.startDate = searchCriteria.cargoCutOff.startDate;
            }
            if (searchCriteria.cargoCutOff != null && searchCriteria.cargoCutOff.endDate != null) {
               this.dispatchLoadSearch.cargoCutOff.endDate = searchCriteria.cargoCutOff.endDate;
            }
            if (searchCriteria.apptDate != null && searchCriteria.apptDate.startDate != null) {
               this.dispatchLoadSearch.apptDate.startDate = searchCriteria.apptDate.startDate;
            }
            if (searchCriteria.apptDate != null && searchCriteria.apptDate.endDate != null) {
               this.dispatchLoadSearch.apptDate.endDate = searchCriteria.apptDate.endDate;
            }
            if (searchCriteria.moveInDate != null && searchCriteria.moveInDate.startDate != null) {
               this.dispatchLoadSearch.moveInDate.startDate = this.convertDateForDatePicker(searchCriteria.moveInDate.startDate,"");
            }
            if (searchCriteria.moveInDate != null && searchCriteria.moveInDate.endDate != null) {
               this.dispatchLoadSearch.moveInDate.endDate = this.convertDateForDatePicker(searchCriteria.moveInDate.endDate,"");
            }
            if (searchCriteria.inGateDate != null && searchCriteria.inGateDate.startDate != null) {
               this.dispatchLoadSearch.inGateDate.startDate = this.convertDateForDatePicker(searchCriteria.inGateDate.startDate,"");
            }
            if (searchCriteria.inGateDate != null && searchCriteria.inGateDate.endDate != null) {
               this.dispatchLoadSearch.inGateDate.endDate = this.convertDateForDatePicker(searchCriteria.inGateDate.endDate,"");
            }
            this.dispatchLoadSearch.loadKey = searchCriteria.loadKey;
            this.dispatchLoadSearch.source = searchCriteria.source;
            this.dispatchLoadSearch.chassisNo = searchCriteria.chassisNo;
            this.dispatchLoadSearch.ctnrType = searchCriteria.ctnrType;
            this.dispatchLoadSearch.carrier = searchCriteria.carrier;
            this.dispatchLoadSearch.customerOrder = searchCriteria.customerOrder;
            this.dispatchLoadSearch.deliveryOrder = searchCriteria.deliveryOrder;
            this.dispatchLoadSearch.loadStatus = searchCriteria.loadStatus;
            this.dispatchLoadSearch.pushStatus = searchCriteria.pushStatus;
            this.dispatchLoadSearch.stageType = searchCriteria.stageType;
            this.dispatchLoadSearch.filter = searchCriteria.filter;
            this.dispatchLoadSearch.selectDType = searchCriteria.selectDType;
            this.dispatchLoadSearch.fromPage = searchCriteria.fromPage;

        }
    },

    setStageSearchFromLoad() {
        if (this.dispatchLoadSearch) {
           this.searchRequest.loadStatus = this.dispatchLoadSearch.loadStatus;
           this.searchRequest.receivingWindow = this.dispatchLoadSearch.receivingWindow;
           this.searchRequest.pushStatus = this.dispatchLoadSearch.pushStatus;
           this.searchRequest.cargoCutOff.startDate = this.dispatchLoadSearch.cargoCutOff.startDate;
           this.searchRequest.cargoCutOff.endDate = this.dispatchLoadSearch.cargoCutOff.endDate;
           this.searchRequest.driverGroup = this.dispatchLoadSearch.driverGroup;
           this.searchRequest.driverId = this.dispatchLoadSearch.driverId;
           this.searchRequest.pickUpLocation = this.dispatchLoadSearch.pickUpLocation;
           this.searchRequest.destination = this.dispatchLoadSearch.destination;
           this.searchRequest.chassisNo = this.dispatchLoadSearch.chassisNo;
           this.searchRequest.loadKey = this.dispatchLoadSearch.loadKey;
           this.searchRequest.carrier = this.dispatchLoadSearch.carrier;
           this.searchRequest.customerOrder = this.dispatchLoadSearch.customerOrder;
           this.searchRequest.ctnrType = this.dispatchLoadSearch.ctnrType;
           this.searchRequest.deliveryOrder = this.dispatchLoadSearch.deliveryOrder;
           this.searchRequest.bookingNo = this.dispatchLoadSearch.bookingNo;
           this.searchRequest.containerNo = this.dispatchLoadSearch.containerNo;
           this.searchRequest.moveInDate.startDate = this.dispatchLoadSearch.moveInDate.startDate;
           this.searchRequest.moveInDate.endDate = this.dispatchLoadSearch.moveInDate.endDate;
           this.searchRequest.inGateDate.startDate = this.dispatchLoadSearch.inGateDate.startDate;
           this.searchRequest.inGateDate.endDate = this.dispatchLoadSearch.inGateDate.endDate;
        }
    },

    getDateDiffForDatePicker(date,offset) {
        var day = "";
        var month = "";
        var year = "";
        var newdate = new Date();
        if (date) {
           //console.log("date input: " + date);
          //  if (date.toString().indexOf("T") > 0) {
          //     dateString = date.toString().substr(1, date.toString().indexOf("T") - 1);
          //     console.log("convert date for date picker: " + Date(dateString).getMonth());
          //     return moment(dateString);      
          //  }   
          //  else {
          //     return date;
          //  }
          var processDate = new Date(date);
          if (offset && offset != 0)
             processDate.setDate(newdate.getDate() - offset);
          //console.log("process date after adjusted: " + processDate);   
          year = processDate.getFullYear();
          month = processDate.getMonth() + 1;
          day = processDate.getDate();
          if (month && month.toString().length < 2) {
             month = "0" + month;
          }
          if (day && day.toString().length < 2) {
             day = "0" + day;
          }
          //console.log("date (" + type + ") input in format: " +  month + "/" + day + "/" + year );
          return month + "/" + day + "/" + year;
        }
        else {
          //console.log("no date (" + type + ") input in format: ");
          return date;
        }
    },

    changeAsgDriverId(item) {
        var pushstatus = item.pushStatus;
        //console.log("asg driver push status: " + item.pushStatus);
        //return (id, name, unit, weight, plate, trail) => {
        return (driver) => {  
          if (this.isAsgDriver == true) {
             //if (pushstatus && pushstatus != "C" && pushstatus != "R" && pushstatus != "REJ" && pushStatus != "P") {
                if (driver && driver != "")
                    pushstatus = "A";
                else
                    pushstatus = null;    
             //}
          }
          //console.log("driver Id: " + id + " plate: " + plate);
          //item.driverId = id;
          item.driverId = driver;
          //item.truckId = plate;
          item.pushStatus = pushstatus;
          //item.driverPh = name;
          //item.driverLP = plate;
          // item.containerNo = trail;
          //console.log("driver Id in item: " + item.driverId);
          
        };
    },

    async toggleItemLink(item) {
        const logId = "DISPATCH";
        const imgType = "C";
        this.isPictureModalShowing = true;
        this.isLoading = true;
        //this.photos = (await api.post('/api/w/ccr/photo/getCCRPhoto', { logId: logId, imageType: imgType, imagePath: item.driverCntrImg }));
        this.photos = (await newAPIPost('/api/w/ccr/photo/getCCRPhoto', { logId: logId, imageType: imgType, imagePath: item.driverCntrImg }));
        //console.log("photos length: " + this.photos.length);
        if (item.loadKey != null)
           this.photoZipFileName = `${logId}_${item.loadkey}.zip`;
        else
           this.photoZipFileName = `${logId}_` + imgType + `.zip`;
        this.filePrefixForEachFile = `${item.containerNo}-`;
        this.photoTitle = "Container Image";
        //console.log(this.photos)

    },

    chkItemPushStatus(item) {
       if (item.pushStatus == "REJ" || item.pushStatus == "R" || item.pushStatus == "C" || item.pushStatus == "A" || item.pushStatus == "P") 
           return false;
        else 
           return true;  
    },

     onSelectDType(val) {
        //console.log("Dispatch type: " + val);
        this.selectDType = val;
     },
     
     doSearch() {

        const {
          users,
          teams,
          salesOffice,
        } = this.searchRequest;
        this.active = false;

        this.items = [];
        //this.searchRequest.chzStartDate.startDate = moment().subtract(2,'months').startOf('d').toDate();
        //this.searchRequest.chzStartDate.endDate = moment().add(2,'months').endOf('d').toDate();
        //console.log("search request-loadStatus: " + this.searchRequest.loadStatus);

        this.searchRequest.salesOffice = "LGB";
        //console.log("select D type: " + this.selectDType);
        // if (this.selectDType == "YE") {
        //     console.log("search:YardExportList");
        //     this.searchRequest.type = "";
        //     this.$store.dispatch('loadYardExportList', this.searchRequest);
        // }
        // else if (this.selectDType == "I") {
        //     console.log("search:ImportLoadList");
        //     this.searchRequest.type = "YI";
        //     this.$store.dispatch('importLoadList', this.searchRequest);
        // }
        // else if (this.selectDType == "E") {
        //     console.log("search:DirectExportList");
        //     this.searchRequest.type = "YE";
        //     this.$store.dispatch('directExportList', this.searchRequest);
        // }  
        // else if (this.selectDType == "TL") {
        //     console.log("search:TruckLoadList");
        //     this.searchRequest.type = "YT";
        //     this.$store.dispatch('truckLoadList', this.searchRequest);
        // }  
        this.searchRequest.type = "";
        if (this.bobtailOnly == true)
        {
           this.searchRequest.bobtailOnly = this.bobtailOnly;  
        }

        //console.log("stage searchrequest driver: " + this.searchRequest.driverId);
        var sendToReq = JSON.parse(JSON.stringify(this.searchRequest));
        sendToReq.driverId = this.getContentFromBrace(this.searchRequest.driverId);
        sendToReq.costRelevant = this.getContentFromBrace(this.searchRequest.costRelevant);
        console.log("searchRequest stageType: " + sendToReq.stageType);
        sendToReq.stageType = this.getContentFromBrace(this.searchRequest.stageType);      
        if (this.searchRequest.cargoCutOff.startDate)
            sendToReq.cargoCutOff.startDate = this.convertDateForMoveIn(this.searchRequest.cargoCutOff.startDate,"-");
        if (this.searchRequest.cargoCutOff.endDate)
            sendToReq.cargoCutOff.endDate = this.convertDateForMoveIn(this.searchRequest.cargoCutOff.endDate,"-");
        if (this.searchRequest.moveInDate.startDate)
            sendToReq.moveInDate.startDate = this.convertDateForMoveIn(this.searchRequest.moveInDate.startDate,"-");
        if (this.searchRequest.moveInDate.endDate)
            sendToReq.moveInDate.endDate = this.convertDateForMoveIn(this.searchRequest.moveInDate.endDate,"-");
        if (this.searchRequest.inGateDate.startDate)
            sendToReq.inGateDate.startDate = this.convertDateForMoveIn(this.searchRequest.inGateDate.startDate,"-");
        if (this.searchRequest.inGateDate.endDate)
            sendToReq.inGateDate.endDate = this.convertDateForMoveIn(this.searchRequest.inGateDate.endDate,"-");
        if (this.searchRequest.apptDate.startDate)
            sendToReq.apptDate.startDate = this.convertDateForMoveIn(this.searchRequest.apptDate.startDate,"-");
        if (this.searchRequest.apptDate.endDate)
            sendToReq.apptDate.endDate = this.convertDateForMoveIn(this.searchRequest.apptDate.endDate,"-");
        // if (this.searchRequest.moveInDate.startDate)
        //      this.searchRequest.moveInDate.startDate = this.convertDateForMoveIn(this.searchRequest.moveInDate.startDate,"-");
        // if (this.searchRequest.moveInDate.endDate)
        //      this.searchRequest.moveInDate.endDate = this.convertDateForMoveIn(this.searchRequest.moveInDate.endDate,"-");
        // if (this.searchRequest.inGateDate.startDate)
        //      this.searchRequest.inGateDate.startDate = this.convertDateForMoveIn(this.searchRequest.inGateDate.startDate,"-");
        // if (this.searchRequest.inGateDate.endDate)
        //      this.searchRequest.inGateDate.endDate = this.convertDateForMoveIn(this.searchRequest.inGateDate.endDate,"-");
        if (this.searchRequest.appointment == "")
          sendToReq.appointment = null;
        if (this.searchRequest.driverId == "")
          sendToReq.driverId = null;   
        //console.log("stage searchrequest driver(after): " + this.searchRequest.driverId);

        this.$store.dispatch('loadDispatchStageList', sendToReq);

        this.isSetDriverGroup = false;
        this.isSetAppointment = false;
        this.isAsgDriver = false;
        this.isSetPin = false;
        this.isConfirm = false;
        this.disableSave = true;
        this.disableAppt = true;

        // switch (this.selectDType) {
        //   default:
        //     this.searchRequest.type = "";
        //     console.log("search:YardExportList");
        //     this.$store.dispatch('loadYardExportList', this.searchRequest);
        //   case 'I':
        //     this.searchRequest.type = "YI";
        //     console.log("search:ImportLoadtList");
        //     this.$store.dispatch('importLoadList', this.searchRequest);
        //   case 'E':
        //     this.searchRequest.type = "YE";
        //     console.log("search:DirectExportList");
        //     this.$store.dispatch('directExportList', this.searchRequest);
        //   case 'TL':      
        //     this.searchRequest.type = "YT";
        //     console.log("search:TruckloadList");
        //     this.$store.dispatch('truckLoadList', this.searchRequest);
        // }
     
     },


    //  async doCopy() {
    //     const request = this.getSelectedItems[0];
    //     if (request.loadKeyWithStageNo == null)
    //     {
    //       alert('There is no stage selected');
    //       return;
    //     }
    //     const data = {
    //       companyOffice: "GST_" + request.salesOffice,
    //       loadKeyWithStageNo: request.loadKeyWithStageNo,
    //       type: request.type || "YY",
    //       loadKey: request.seqNo,
    //       carrier: request.carrier,
    //       action: "COPY",
    //     }

    //     console.log(data);

    //     api.post("/api/w/gst/WebCopyDeleteStage", data)
    //     .then(() => {
    //       this.$store.commit('clearApiError');
    //       this.doSearch();
    //     });

    //  },


    async doDeleteBooking(){
        const request = this.getSelectedItems[0];
        const data = {
          user: 'GST_SYSTEM',
          seqNo: request.seqNo,
          mode: "REMOVE"
        }
        //api.post("/api/w/DOs/WebAssignDoHeaderWithStage", data)
        newAPIPost("/api/w/DOs/WebAssignDoHeaderWithStage", data)
        .then(() => {
          this.$store.commit('clearApiError');
          this.doSearch();
        });
    },


     async doDeleteStage(){
      const request = this.getSelectedItems[0];
        //console.log(request);
        const data = {
          companyOffice: "GST_" + request.salesOffice,
          loadKeyWithStageNo: request.loadKeyWithStageNo,
          type: request.type || "YY",
          loadKey: request.seqNo,
          action: "DELETE_STAGE",
        }
        if (request.loadKeyWithStageNo == null)
        {
          alert('There is no stage selected');
          return;
        }

        //api.post("/api/w/gst/WebCopyDeleteStage", data)
        newAPIPost("/api/w/gst/WebCopyDeleteStage", data)
        .then(() => {
          this.$store.commit('clearApiError');
          this.doSearch();
        });

     },

     async onfresh(id, ticket, mode, loads) {
       //console.log(`${id} , ${ticket} , ${mode}`);
       this.notifyMessage =  null;

       switch(mode)
       {
         case 'STR':
            this.notifyMessage = `Load ${id} has been scaled tw with scale ticket: ${ticket}.`;
         break;

         case 'SWR':
            this.notifyMessage = `Load ${id} with scale ticket: ${ticket} has been scaled gw.`;
         break;

         case 'ASN':
            this.notifyMessage = `DO ${id} with booking#: ${ticket} has been assigned with your selection. Loads: {${loads}}`;
         break;

         case 'UASN':
            this.notifyMessage = `DO ${id} with booking#: ${ticket} has been assigned with your selection. Loads: {${loads}}`;
         break;

         default:
         break;
       }
    
       this.doSearch();
     },

     async doDeleteLoad(){
      const request = this.getSelectedItems[0];
        //console.log(request);
        const data = {
          companyOffice: "GST_" + request.salesOffice,
          loadKeyWithStageNo: request.loadKeyWithStageNo,
          type: request.type || "YY",
          loadKey: request.seqNo,
          action: "DELETE_LOAD",
        }

        //api.post("/api/w/gst/WebCopyDeleteStage", data)
        newAPIPost("/api/w/gst/WebCopyDeleteStage", data)
        .then(() => {
          this.$store.commit('clearApiError');
          this.doSearch();
        });

     }, 


     doClear(){
      this.filter = "";
      // this.items = this.getYardExportList
      //this.updateItems(this.getYardExportList);
      // this.searchRequest.receivingWindow = "";
      // this.searchRequest.cargoCutOff.startDate = "";
      // this.searchRequest.cargoCutOff.endDate = "";
      // this.searchRequest.apptDate.startDate = "";
      // this.searchRequest.apptDate.endDate = "";
      // this.searchRequest.bookingNo = "";
      // this.searchRequest.stageStatus = "";
      // this.searchRequest.driverGroup = "";
      // this.searchRequest.appointment = "";
      // this.searchRequest.pushStatus = "";
      // this.searchRequest.loadStatus = ["ASG","LD"]
      // this.searchRequest.freightType = "";
      // this.searchRequest.driver = "";
      // this.searchRequest.chassisNo = "";
      // this.searchRequest.containerNo = "";
      // this.searchRequest.deliveryOrder = "";
      // this.searchRequest.carrier = "";
      // this.searchRequest.customerOrder = "";
      // this.searchRequest.loadKey = "";
    this.$nextTick(() => {
        if (this.$el && this.$el.querySelectorAll) {
          _(this.$el.querySelectorAll('.searchPanel .md-field button.md-input-action.md-clear'))
            .each((it) => {
              it.click();
          });
        }
        this.searchRequest = getInitSearch();
        this.searchRequest.salesOffice = 'LGB';
        //this.items = this.getOutboundsList;
        //this.updateItems(this.getOutboundsList);
        //this.edit = getInitEdit();
      });

     },

     editDriverGroup() {
       this.isSetDriverGroup = true;
       this.disableSave = false;
     },

     doAsgDriver() {
       this.isAsgDriver = true;
       this.disableSave = false;
     },

     doLoad() {
      var request = this.dispatchLoadSearch;
      //console.log("req: " + JSON.stringify(request));
      this.$router.push({  
          name: "Load" , 
          params: { req: JSON.stringify(request) }})
     },

     editAppt() {
       this.disableAppt = false;
       this.disableSave = false;
     },

     async doChange(){
       
      const request = this.getSelectedItems[0];
        if (request.loadKeyWithStageNo == null)
        {
          alert('There is no stage selected');
          return;
        }

        if (request.stageStatus == 'STC' || request.stageStatus == 'SUC'  )
        {
          alert('The stage has been confirmed or under check, it can not be changed this time!');
          return;
        }

        this.$refs.DispatchFormChange.openDialog(request);

  },


  async doCopy(){
      const request = this.getSelectedItems[0];
        if (request.loadKeyWithStageNo == null)
        {
          alert('There is no stage selected');
          return;
        }

        this.$refs.DispatchFormCopy.openDialog(request);

  },

  doDispatch(){
      do {
          this.selectedItems.pop();
      } while (this.selectedItems.length > 0)
      //console.log("selectedItems length: " + this.selectedItems.length);
      var items = this.items.forEach( it => {
        if (it.selected == true)
        {
          //console.log("selected: " + it.selected);
          this.selectedItems.push(it);
        }
      })
      //console.log("dispatch items: " + JSON.stringify(this.selectedItems));
      const request = this.selectedItems[0];
      this.$refs.DispatchFormCopy.openDialog(request);

  },

  doSingleDispatch(item){
      // const request = item;
      // this.$refs.DispatchFormCopy.openDialog(request);
      //console.log("single dispatch item: " + JSON.stringify(item));
      // this.cockpitRequest.mode = "YY";
      // this.cockpitRequest.carrierName = "";
      // this.cockpitRequest.customerPO = "";
      // this.cockpitRequest.route = "";
      // this.cockpitRequest.deliveryOrder = "";
      // if (item.loadKey == null)
      //    this.cockpitRequest.loadKey = item.seqNo;
      // else
      //    this.cockpitRequest.loadKey = item.loadKey; 
      if (item.loadKey == null)
         item.loadKey = item.seqNo;
      this.singleReq.push(item);    
      this.$router.push({  
            name: "cockpit" , 
            params: { req: JSON.stringify(this.singleReq) }
      })

  },

  getMasterDataByName(group, tagId) {
      //console.log("get master data name: " + group + ", " + tagId);
      if (!tagId) {
        return "";
      }
      //console.log("master name: " + this.getMasterDataName(group, tagId));
      return this.getMasterDataName(group, tagId);
      //return "";
  },

  getContentFromBrace(inputVal) {
      var openbraceIndx = -1;
         var closebraceIndx = -1;
         var retVal = "";
         if (inputVal && inputVal != "") {
            openbraceIndx = inputVal.indexOf("(");
            closebraceIndx = inputVal.indexOf(")");
            if (openbraceIndx >= 1) {
               if (closebraceIndx > openbraceIndx) {
                  retVal = inputVal.substr(openbraceIndx + 1, closebraceIndx - openbraceIndx - 1);
                  //console.log("retVal from brace: " + retVal);
               } else if (closebraceIndx < 0) {
                  retVal = inputVal.substr(openbraceIndx + 1, inputVal.length - openbraceIndx);
                  //console.log("retVal from brace1: " + retVal);
               }
            } else {
               retVal = inputVal;
            }
            return retVal;
         } else {
            return inputVal;
         }    
    },

  handleTypeChanged(id) {
      this.searchRequest.type = id;
    },

  handleStageTypeChanged(id) {
      this.searchRequest.stageType = id;
  },
  
  handleCarrierChanged(id) {
      this.searchRequest.carrier = id;
    },


  handleDriverRequestChanged(id) {
      this.searchRequest.driver = id;
    },

    handleCostRelChanged(id) {
        this.searchRequest.costRelevant = id;
    },





     handlePickLocationChanged(item) {
      return (pickupLocation) => {
        if (pickupLocation) {
          item.pickupLocationCode = pickupLocation.tagId;
          item.pickUpLocationName = pickupLocation.tagName;
          // item.pickUpLocation = pickupLocation;
        } else {
           //item.pickUpLocationId = null;
          // item.pickUpLocationName = null;
          // item.pickUpLocation = null;
        }
      };
    },



    handleDeliverLocationChanged(item) {
      return (pickupLocation) => {
        if (pickupLocation) {
          item.deliverLocationCode = pickupLocation.tagId;
          item.deliverLocationName = pickupLocation.tagName;
          // item.pickUpLocation = pickupLocation;
        } else {
           //item.pickUpLocationId = null;
          // item.pickUpLocationName = null;
          // item.pickUpLocation = null;
        }
      };
    },

    handlePushStatusChanged(id) {
      this.searchRequest.pushStatus = id;
    },
    
    convertDateForMoveIn(date, separator) {
        var day = "";
        var month = "";
        var year = "";
        if (date) {
           //console.log("date input: " + date);
          //  if (date.toString().indexOf("T") > 0) {
          //     dateString = date.toString().substr(1, date.toString().indexOf("T") - 1);
          //     console.log("convert date for date picker: " + Date(dateString).getMonth());
          //     return moment(dateString);      
          //  }   
          //  else {
          //     return date;
          //  }
          //console.log("convertDateForMoveIn: " + date);
          //var t_processDate = new Date(date).toISOString().split('T')[0];
          //console.log("convertDateForMoveIn - t process date: " + t_processDate);
          var processDate = new Date(date);
          console.log("convertDateForMoveIn - process date: " + date);
          year = processDate.getFullYear();
          month = processDate.getMonth() + 1;
          day = processDate.getDate();
          if (month && month.toString().length < 2) {
             month = "0" + month;
          }
          if (day && day.toString().length < 2) {
             day = "0" + day;
          }
          console.log("date1 (" + separator + ") input in format: " +  month + "/" + day + "/" + year );
          if (separator && separator == "-")
              return year + separator + month + separator + day;
          else 
              return month + "/" + day + "/" + year;
        }
        else {
          //console.log("no date (" + type + ") input in format: ");
          return date;
        }
    },

    convertDateForDatePicker(date, type) {
        var day = "";
        var month = "";
        var year = "";
        if (date) {
           //console.log("date input: " + date);
          //  if (date.toString().indexOf("T") > 0) {
          //     dateString = date.toString().substr(1, date.toString().indexOf("T") - 1);
          //     console.log("convert date for date picker: " + Date(dateString).getMonth());
          //     return moment(dateString);      
          //  }   
          //  else {
          //     return date;
          //  }
          if (date.indexOf("T") < 1 && date.indexOf("-") > 1) date = date + "T00:00:00" 
          var processDate = new Date(date);
          year = processDate.getFullYear();
          month = processDate.getMonth() + 1;
          day = processDate.getDate();
          if (month && month.toString().length < 2) {
             month = "0" + month;
          }
          if (day && day.toString().length < 2) {
             day = "0" + day;
          }
          //console.log("date (" + type + ") input in format: " +  month + "/" + day + "/" + year );
          return month + "/" + day + "/" + year;
        }
        else {
          //console.log("no date (" + type + ") input in format: ");
          return date;
        }
    },


    doCockPit() {
      const request = this.uniqByLast(this.getSelectedItems, it => it.seqNo);
          //console.log(request);
          request.forEach((it) => {
            //it.mode = 'YY';
            it.mode = it.type;
            //it.carrierName = "";
            //it.customerPO = "";
            it.route = "";
            //it.deliveryOrder = "";
            if (it.loadKey == null)
            {
              it.loadKey = it.seqNo;
            }
          });
          this.searchCriteria.containerNo = this.searchRequest.containerNo;
          this.searchCriteria.receivingWindow = this.searchRequest.receivingWindow;
          this.searchCriteria.salesOffice = this.searchRequest.salesOffice;
          this.searchCriteria.pickupLocation = this.searchRequest.pickupLocation;
          this.searchCriteria.bookingNo = this.searchRequest.bookingNo;
          this.searchCriteria.destination = this.searchRequest.destination;
          this.searchCriteria.appointment = this.searchRequest.appointment;
          this.searchCriteria.driver = this.searchRequest.driver;
          this.searchCriteria.driverGroup = this.searchRequest.driverGroup;
          this.searchCriteria.costRelevant = this.searchRequest.costRelevant;
          this.searchCriteria.freightType = this.searchRequest.freightType;
          this.searchCriteria.loadKey = this.searchRequest.loadKey;
          this.searchCriteria.source = this.searchRequest.source;
          this.searchCriteria.chassisNo = this.searchRequest.chassisNo;
          this.searchCriteria.carrier = this.searchRequest.carrier
          this.searchCriteria.customerOrder = this.searchRequest.customerOrder;
          this.searchCriteria.deliveryOrder = this.searchRequest.deliveryOrder;
          this.searchCriteria.loadStatus = this.searchRequest.loadStatus;
          this.searchCriteria.stageStatus = this.searchRequest.stageStatus;
          this.searchCriteria.pushStatus = this.searchRequest.pushStatus;
          this.searchCriteria.stageType = this.searchRequest.stageType;
          this.searchCriteria.cargoCutOff.startDate = this.searchRequest.cargoCutOff.startDate;
          this.searchCriteria.apptDate.startDate = this.searchRequest.apptDate.startDate;
          this.searchCriteria.cargoCutOff.endDate = this.searchRequest.cargoCutOff.endDate;
          this.searchCriteria.apptDate.endDate = this.searchRequest.apptDate.endDate;
          this.searchCriteria.moveInDate.startDate = this.searchRequest.moveInDate.startDate;
          this.searchCriteria.moveInDate.endDate = this.searchRequest.moveInDate.endDate;
          this.searchCriteria.inGateDate.startDate = this.searchRequest.inGateDate.startDate;
          this.searchCriteria.inGateDate.endDate = this.searchRequest.inGateDate.endDate;
          this.searchCriteria.filter = this.filter;
          this.searchCriteria.fromPage = "S";
          //console.log("request for cockpit: " + JSON.stringify(request));
          //request.push(this.searchCriteria);
          this.$router.push({  
            name: "cockpit" , 
            //params: { req: JSON.stringify(request) }})
            params: { req: JSON.stringify(request), searchCriteria: JSON.stringify(this.searchCriteria)}})


    },

     async doSave() {
      
    
      //const editItem = this.getEditingItems.filter(it  => this.hasBeenChanged(it));
      const editItem = (this.items).filter(it  => this.hasBeenChanged(it));
      //console.log("doSave editItem: " + editItem.length);
      const requests = _(editItem)
        .chain()
        .map(it => ({
          salesOffice: it.salesOffice,
          loadKeyWithStageNo: it.loadKeyWithStageNo,
          appointment: it.appointment,
          apptDate: it.apptDate,
          apptTime: it.apptTime,
          driverId: it.driverId,
          truckId: it.truckId,
          costRelevant: it.costRelevant,
          freightType: it.freightType,
          dispatcherInstruction: it.dispatcherInstruction,
          containerPickupLocation: it.containerPickupLocation,
          containerDropOffLocation: it.containerDropOffLocation,
          offsiteScale: it.offsiteScale,
          seqNo: it.seqNo,
          ccicDropOffLocationCode: it.ccicDropOffLocationCode,
          pickupLocationCode: it.pickupLocationCode,
          pickUpLocationName: it.pickUpLocationName,
          deliverLocationCode: it.deliverLocationCode,
          deliverLocationName: it.deliverLocationName,
          deliveryOrder: it.deliveryOrder,
          driverGroup: it.driverGroup,
          //containerNo: it.containerNo
        })).value();
    
      // await Promise.all(this.getEditingItems.map(it => api.post('/api/w/ccic/application/update', it)));
       
       //console.log("doSave requests: " + JSON.stringify(requests));

       //api.post("/api/w/gst/updateyardstage", requests)
       newAPIPost("/api/w/gst/updateyardstage", requests)
        .then(() => {
          this.$store.commit('clearApiError');
          this.doSearch();
        });
       this.disableSave = true;
       this.isSetDriverGroup = false;
       this.isAsgDriver = false;
       this.disableAppt = true;
    },


    doEdit() {

      const confirmedStage = this.getSelectedItems.filter(it => it.stageStatus == "STC" || it.stageStatus == "SUC")
      if (confirmedStage.length != 0)
      {
         alert("Some stages have been confirmed or under check , it can not be changed at this moment!!");
        return;
      }
      this.getSelectedItems.forEach((it) => {
        it.editing = true;
      });
    },

    getBookingAssign() {
       const loads = this.getSelectedItems
       this.$refs.OutboundBooking.openDialog(loads);
    },

    getBookingUnAssign() {
       if (!window.confirm('Unassign Selected Items?')) {
         return;
       }
      
       const load = this.getSelectedItems
       const office = 'LGB'
       const si = this.getSelectedItems[0].deliveryOrder
       const obk = this.getSelectedItems[0].bookObl
       const ibds = this.getSelectedItems[0].ibs
       const usr = 'GST_SYSTEM'
       const seqn = this.getSelectedItems[0].seqNo
       //console.log("Set Unassign");
       const request = {
         salesOffice: office,
         deliveryOrder: si,
         ibs: ibds,
         user: usr,
         seqNo: seqn,
       };

       //console.log(JSON.stringify(request));
       //api.post("/api/w/DOs/WebUnAssignBooking", request).then((res) => {
       newAPIPost("/api/w/DOs/WebUnAssignBooking", request).then((res) => {
          this.showDialog = false;
          this.$store.commit("clearApiError");
          this.action(si, obk, 'UASN', seqn);
  

       });
    },

    getChassisUsedDate(item){
        // if (item.chzEndDate == null)
        // {
        //   return moment().diff(moment(item.chzStartDate), 'days')
        // }
        // else
        // {
        //   return moment(item.chzEndDate).diff(moment(item.chzStartDate), 'days')
        // }
        console.log(`item from getChassisUsedDate: ${JSON.stringify(item)}`);
        console.log("chzStartDate: " + item.chzStartDate + " chzEndDate: " + item.chzEndDate + " chzUseDay: " + item.chzUseDay);
        //if (item && item.chzUseDay == null) {
        if (item) {  
          if (item.chzStartDate != null) {
            if (item.chzEndDate == null)
            {
              //console.log("getchassisuseddate: chzenddate is null"); 
              return moment().diff(moment(item.chzStartDate), 'days') + 1;
            }
            else
            {
              //console.log("getchassisuseddate: chzenddate is not null"); 
              return moment(item.chzEndDate).diff(moment(item.chzStartDate), 'days') + 1;
            }
          } else {
            //console.log("chzStart is null");
            //alert("Out gate date needs to be filled to get Chassis use day!");
            return 0;
          }
        } else {
            //console.log("item is null") 
            //alert("Chassis use day unable to find without stage info!");
            return 0;
        }

    },

    getPushStatusInfo(status) {
     var retStatus = "";
     //console.log("push status: " + status);
     if (status && status != "") {
        //retType = this.getMasterDataName("STC_STAGE_TYPE",type);
        retStatus = this.getMasterDataName("PUSH_STATUS",status);
        //console.log("return type: " + retStatus);
     }
     return retStatus;     
  },

    async doOutGate(){
        const request = this.getSelectedItems;
        if (request.filter(it => it.stageType == "OUT" || it.stageType == null).length != 0)
        {
          alert("Can not out gate for this item!");
          return 
        }
        const data = request.map(it => ({
          salesOffice: it.salesOffice,
          user: it.user,
          type: it.type,
          appointment: it.appointment,
          apptDate: dateFormat.getLocalDate(it.apptDate),
          //pickupDate: dateFormat.getLocalDate(it.pickupDate),
          driverId: it.driverId,
          truckId: it.truckId,
          chassisStartDate :dateFormat.getLocalDate(moment())
        }));


        //await api.post("/api/w/gst/WebYardGroupOutGate", data)
        await newAPIPost("/api/w/gst/WebYardGroupOutGate", data)
        .then(() => {
          this.$store.commit('clearApiError');
          // $('.btn-search-loadlist-container')
          //   .click();
        });
        this.doSearch();

    },


    doDownloadExcel(){
     const request = toGenerateExcelRequest(
        this.$el.querySelector('.data-table-container .inner-container'),
        'Dispatch-Stage-List.xls',
        1,
      );
        //request.heads = _(request.heads).take(52);
        //request.heads = _(request.heads).take(47);
        request.heads = _(request.heads).take(56);
        request.rows = _(this.items)
        .map(item => [
          item.salesOffice,
          item.receivingWindow,
          item.loadStatus,
          item.stageStatus,
          item.driverId,
          item.containerNo,
          item.chassisNo,
          item.carrier,
          item.stage,
          item.stageType,
          item.freightType,
          item.costRelevant,
          item.stageDispatcherInstruction,
          item.bookingNo,
          item.emptyPulledBooking,
          (item.mismatchBooking == true) ? 'X' : '',
          dateFormat.date(item.cutLFD),
          item.dropOffTml,
          item.appointment,
          dateFormat.date(item.apptDate),
          item.apptTime,
          item.driverGroup,
          item.driverId,
          (item.driverCntrImg != null && item.driverCntrImg != '')? '1 image' : '0 image',
          this.getPushStatusInfo(item.pushStatus),
          item.ctnrType,
          item.source,
          this.getChassisUsedDate(item) + " Days",
          item.manualchassisuseday,
          dateFormat.date(item.chzEndDate),
          item.loadKey,
          item.yardLoc,
          item.customerOrder,
          item.sealNumber,
          item.scaleTicket,
          item.pickupLoc,
          item.pickupTml,
          item.deliveryTo,
          item.truckId,
          item.dispatchInstuction,
          item.deliveryOrder,
          item.stcLoadConfirmedBy,
          dateFormat.date(item.stcLoadConfirmedAt),
          dateFormat.time(item.stcLoadConfirmedAt),
          item.stcStageConfirmedBy,
          dateFormat.date(item.stcStageConfirmedAt),
          dateFormat.time(item.stcStageConfirmedAt),
          (item.rateChanged == true) ? 'X' : '',
          (item.stcDriverTaskPayConfirmed == true) ? 'X' : '',
          dateFormat.date(item.stcDriverTasksPayConfirmedAt),
          dateFormat.time(item.stcDriverTasksPayConfirmedAt),
          item.stcDriverTaskPayConfirmedBy,
          (item.driverPayConfirmSignImage != null && item.driverPayConfirmSignImage != '') ? '1' : '',
          item.driverPayConfirmKey,
          item.seqNo,
          item.route

          // item.logId,
          // item.yard,
          // item.gateTypeDesc,
          // item.gateNo,
          // item.statusTypeDesc,
          // dateFormat.date(item.logDateTime),
          // dateFormat.time(item.logDateTime),
          // item.plateNo,
          // item.plateImage,
          // item.containerNo,
          // item.containerType,
          // this.getMasterDataByName("CCR_CNTRTYPE",item.containerType),
          // this.getMasterDataByName("CCR_CNTRTYPE_ID",item.containerType),
          // item.containerImage,
          // item.chassisNo,
          // item.chassisImage,
          // item.scaleWeight,
          // item.logStatus,
          // item.status,
          // item.inboundShipment,
          // item.seqNo,
          // item.createdBy,
          // dateFormat.date(item.createdAt),
          // dateFormat.time(item.createdAt),
          // item.updatedBy,
          // dateFormat.date(item.updatedAt),
          // dateFormat.time(item.updatedAt),
          // item.salesOffice,
          // item.receivingWindow,
          // item.loadStatus,
          // item.stageStatus,
          // //item.loadKey,
          // item.containerNo,
          // item.chassisNo,
          // item.carrier,
          // item.stage,
          // item.stageType,
          // item.freightType,
          // item.costRelevant,
          // item.dispatcherInstruction,
          // item.bookingNo,
          // item.cutLFD,
          // item.dropOffTml,
          // item.appointment,
          // dateFormat.date(item.apptDate),
          // dateFormat.time(item.apptDate),
          // item.driverGroup,
          // item.driverId,
          // item.containerImg,
          // this.getPushStatusInfo(item.pushStatus),
          // item.ctnrType,
          // item.source,
          // this.getChassisUsedDate(item),
          // dateFormat.date(item.chzEndDate),
          // item.loadKey,
          // item.yardLoc,
          // item.customerOrder,
          // item.sealNo,
          // item.weightTicket,
          // this.getMasterDataByName("GST_LOCATION",item.pickupLocationCode),
          // item.pickUpTml,
          // item.deliveryTo,
          // item.truckId,
          // item.dispatchInstuction,
          // item.deliveryOrder,
          // item.route, 
        ]);
     const request_bobtail = toGenerateExcelRequest(
        this.$el.querySelector('.data-table-container .inner-container'),
        'Dispatch-Stage-List.xls',
        1,
      );
        //request.heads = _(request.heads).take(52);
        console.log(`heads: ${JSON.stringify(_(request_bobtail).heads)}`);
        request_bobtail.heads = _(request_bobtail.heads).take(11);
        console.log(`this.items: ${JSON.stringify(this.items)}`);
        //var p_items = this.items.filter((it) => {it.freightType == 'CD27' || it.freightType == 'CD06'});
        var p_items = [];
        this.items.forEach((it) => {
           if (it.freightType == 'CD27' || it.freightType == 'CD06')
           {
              p_items.push(it);
           }
        })
        console.log(`p_items: ${JSON.stringify(p_items)}`);
        //request_bobtail.rows = _(this.items)
        request_bobtail.rows = _(p_items)
        .map(item => [
          (item.stageConfirmed == true) ? 'X' : '',
          item.receivingWindow,
          item.emptyoutReceivingWindow,
          item.emptyoutContainerNo,
          item.emptyoutChassisNo,
          item.stageCarrier,
          dateFormat.date(item.moveInDate),
          item.driverId,
          item.emptyoutBookingNo,
          item.stageBookingNo,
          this.getMasterDataByName('GST_RATE_COST', item.freightType)
          //item.freightType
          //item.chassisNo

          // item.logId,
          // item.yard,
          // item.gateTypeDesc,
          // item.gateNo,
          // item.statusTypeDesc,
          // dateFormat.date(item.logDateTime),
          // dateFormat.time(item.logDateTime),
          // item.plateNo,
          // item.plateImage,
          // item.containerNo,
          // item.containerType,
          // this.getMasterDataByName("CCR_CNTRTYPE",item.containerType),
          // this.getMasterDataByName("CCR_CNTRTYPE_ID",item.containerType),
          // item.containerImage,
          // item.chassisNo,
          // item.chassisImage,
          // item.scaleWeight,
          // item.logStatus,
          // item.status,
          // item.inboundShipment,
          // item.seqNo,
          // item.createdBy,
          // dateFormat.date(item.createdAt),
          // dateFormat.time(item.createdAt),
          // item.updatedBy,
          // dateFormat.date(item.updatedAt),
          // dateFormat.time(item.updatedAt),
          // item.salesOffice,
          // item.receivingWindow,
          // item.loadStatus,
          // item.stageStatus,
          // //item.loadKey,
          // item.containerNo,
          // item.chassisNo,
          // item.carrier,
          // item.stage,
          // item.stageType,
          // item.freightType,
          // item.costRelevant,
          // item.dispatcherInstruction,
          // item.bookingNo,
          // item.cutLFD,
          // item.dropOffTml,
          // item.appointment,
          // dateFormat.date(item.apptDate),
          // dateFormat.time(item.apptDate),
          // item.driverGroup,
          // item.driverId,
          // item.containerImg,
          // this.getPushStatusInfo(item.pushStatus),
          // item.ctnrType,
          // item.source,
          // this.getChassisUsedDate(item),
          // dateFormat.date(item.chzEndDate),
          // item.loadKey,
          // item.yardLoc,
          // item.customerOrder,
          // item.sealNo,
          // item.weightTicket,
          // this.getMasterDataByName("GST_LOCATION",item.pickupLocationCode),
          // item.pickUpTml,
          // item.deliveryTo,
          // item.truckId,
          // item.dispatchInstuction,
          // item.deliveryOrder,
          // item.route, 
        ]);
      if (this.bobtailOnly)
      {
         this.$store.dispatch('generateExcel', request_bobtail)
           .then((res) => {
              window.open(res.url, 'blank');
         });

      } else {
         this.$store.dispatch('generateExcel', request)
           .then((res) => {
              window.open(res.url, 'blank');
         });
      }
    },




    hasBeenChanged(item) {

      const lhs = _(this.getYardExportList)
        .find(it => it.vueKey === item.vueKey);
      
      if (lhs) {
        return (moment(lhs.apptDate).format() !== moment(item.apptDate).format())
          || (lhs.driverGroup !== item.driverGroup)
          || (lhs.appointment !== item.appointment)
          || (lhs.driverId !== item.driverId)
          || (lhs.truckId !== item.truckId)
          || (lhs.dispatcherInstruction !== item.dispatcherInstruction)
          || (lhs.costRelevant !== item.costRelevant)
          || (lhs.freightType !== item.freightType)
          || (lhs.pickupLocationCode != item.pickupLocationCode)
          || (lhs.deliverLocationCode != item.deliverLocationCode);
      }
      return false;
    },

   changeSelChkBox() {
      //console.log("change check box: " + this.selectAll);
      //console.log("yard export list: " +  JSON.stringify(_(this.items)));
      _(this.items).forEach(
        it => {
          //console.log("check box item: " + JSON.parse(JSON.stringify(it)));
          it.selected = this.selectAll;
        }
      );
   },

   handleDriverChanged(item) {
      return (id) => {
        item.driverId = id;
      };
    },






      async CreateIngate(){
          const selectedItem = this.getSelectedItems[0];
          this.$refs.DispatchForm.openDialog(selectedItem);
      //     const req = {
      //       companyOffice: 'GST_' + selectedItem.salesOffice,
      //       loadKey: selectedItem.seqNo,
      //       stageType: 'IN',
      //       stageTypeWithStatus: 'YY'
      //     }
      //  await  api.post("/api/w/gst/createyardstage", req)
      //   .then(() => {
      //     this.$store.commit('clearApiError');
      //     // $('.btn-search-loadlist-container')
      //     //   .click();
      //   });

       // this.doSearch();


         

      },

    toggleCreateIngate(item) {
     
      if (!!_(this.getEditingItems).find(it => !!this.hasBeenChanged(it)))
      {
          alert("Please save stages changes first!!");
        return;
      }

      if (item.bookingNo != null) return 

      //const selectedItem = this.getSelectedItems[0];
      this.$refs.CreateIngate.openDialog(item);

    
    },


    toggleInstruction(item) {

      if (item.editing == false)
      return 

      this.$refs.Instruction.openDialog(item);
    },

    //getChassisUsedDate(date){
    //      return moment().diff(moment(date), 'days')
    //
    //  },



      mouseOver: function(){
          this.active = true;
      },

      mouseLeave: function() {
       
        this.active = !this.active;
      },


      getDriverName(item){
          const driver = this.drivers.filter(it => it.id == item);
        
          return  driver.length == 0 ? "" : driver[0].name
      },


    handleScroll(e) {
      this.$nextTick(() => {
         if (this.$el && this.$el.querySelector) {
           $(this.$el.querySelector('.table-header'))
             .offset({
               left: -1 * (e.target.scrollLeft - $('.outer-container')
                 .offset().left),
           });
         }
      });  
    },


    uniqByLast(data, key){
      return [
        ...new Map(
          data.map(x => [key(x), x])
        ).values()
      ]
    },


    includeNull(field){
          return field==null ? '' : field;
    },

    isValidCond(values) {
       if (values == null) return false;
       if (values[0])
          return (values.length === 1 && values[0].toString() != "");
       else
          return false;   
    }
    

   },

  }
</script>